export type Language = 'is' | 'en'

export const translations = {
  is: {
    navbar: {
      home: 'Heim',
      about: 'Um mig',
      services: 'Þjónusta',
      contact: 'Hafa samband',
      bookNow: 'Spjöllum saman',
      servicesDropdown: {
        overview: 'Yfirlit',
        courses: 'Námskeið',
        workshops: 'Vinnustofur',
        talks: 'Fræðsla',
      },
    },
    footer: {
      tagline:
        'Þjálfun og ráðgjöf sem byggir á rannsóknum, reynslu og hreinskilni - fyrir leiðtoga og teymi sem vilja gera betur.',
      explore: 'Síður',
      home: 'Heim',
      about: 'Um mig',
      services: 'Þjónusta',
      contact: 'Hafa samband',
      servicesTitle: 'Þjónustusvið',
      newToLeadership: 'Nýr í stjórnunarhlutverkinu',
      conflictAndConversations: 'Ágreiningur og erfið samtöl',
      meetingsAndFacilitation: 'Betri fundir og vinnustofur',
      leadingInComplexity: 'Að leiða í flóknum aðstæðum',
      connectTitle: 'Við skulum tengjast',
      substackNote: 'Greinar og hugsanir á Substack',
      copyright: 'Allur réttur áskilinn.',
      privacy: 'Persónuverndarstefna',
      terms: 'Þjónustuskilmálar',
    },
    home: {
      hero: {
        badge: 'Leiðtogar · Teymi · Samskipti',
        titleLine1: 'Að leiða eða stjórna.',
        titleLine2: 'Munurinn skiptir máli.',
        description:
          'Flest sem við gerum í leiðtogaþjálfun og teymisvinnu skilar minni árangri en við höldum. Það er hægt að gera betur - ef við erum tilbúin að vera heiðarleg um hvað virkar.',
        subDescription:
          'Ég skrifa um þetta á Substack og vinn með leiðtogum og teymum sem vilja gera breytinguna.',
        cta: 'Hafa samband',
        ctaWriting: 'Lesa skrif mín',
        substackBadge: 'Skrif á Substack',
        substackSub: 'Rannsóknarstuddar greinar',
      },
      cta: {
        title: 'Áhugi?',
        description:
          'Við skulum taka spjallið um þínar/ykkar áskoranir og sjá hvort við náum tengingu. Enginn þrýstingur - bara heiðarleg samtal.',
        bookCall: 'Bóka fritt spjall',
        readAbout: 'Lesa um mig',
      },
      writing: {
        sectionLabel: 'Skrif og þankar',
        title: 'Hvað ég er að hugsa um',
        subtitle:
          'Greinar og fyrirlestrar þar sem ég fer yfir hvað rannsóknir segja í raun - og hvað við gerum oft öfugt.',
        series1Label: 'Endurgjöf',
        series1Title: 'Þversögnin um Endurgjöf',
        series1Excerpt:
          'Við höfum flest þá sannfæringu að endurgjöf sé lykillinn að því að þróast og verða betri. Rannsóknir og reyndin er óþægilegri. Fimm greinar sem fara í gegnum hvað við höldum að sé rétt, vs. hvað er rétt, og hvernig það skiptir máli.',
        series2Label: 'Agile',
        series2Title: 'Lærdómar Agile',
        series2Excerpt:
          'Agile hreyfingin fangaði og sýndi fram á mikilvæga lærdóma um hvernig teymi ná árangri í flóknari heimi. Agile hreyfingin villtist einnig af sporinu með ýmislegt. Þessi sería er um þær lexíur sem agile færði okkur, sem og mistökin, og hvað er mikilvægt að skilja og vinna með áfram.',
        series3Label: 'Teymi',
        series3Title: 'Hvernig teymi þróast',
        series3Excerpt:
          'Flestir hafa því miður almennt verri reynslu af teymum og teymisvinnu en góða. Það er mikil synd, og það er ekki tilviljun. Þessi greinaröð skoðar hvað rannsóknir og hvaða nálganir hafa skapað best skilyrði hingað til, ásamt vangaveltum um hvernig árangursrík teymi munu þróast héðan í frá.',
        readOn: 'Lesa á Substack',
        viewAll: 'Sjá allar greinar á Substack',
      },
      ways: {
        sectionLabel: 'Hvernig ég vinn',
        title: 'Fjórar leiðir til að vinna saman',
        subtitle:
          'Ég vinn á mismunandi hátt eftir því hvað hentar þér best - einstaklingsþjálfun, vinnustofur, þjálfun eða sem innbyggður sérfræðingur.',
        learnMore: 'Lesa meira',
        viewAll: 'Sjá alla þjónustu',
        coaching: {
          title: 'Einstaklingsþjálfun',
          desc: 'Reglulegar einstaklingslotur þar sem við förum yfir hlutverkið þitt, áskoranirnar og næstu skref. Byggt á þinni stöðu - ekki almælt ráð.',
        },
        facilitation: {
          title: 'Vinnustofur með lóðsun',
          desc: 'Ég leiði vinnustofur þar sem þátttakendur búa sjálfir til það sem þeir þurfa - undir minni leiðsögn. Hópurinn er í miðjunni, ekki ég.',
        },
        training: {
          title: 'Þjálfun og námskeið',
          desc: 'Blanda saman kennslu og lóðsun - ég kynni aðferðir og ramma, en þátttakendur aðlaga þær og bæta við eigin reynslu.',
        },
        embedded: {
          title: 'Innbyggður sérfræðingur',
          desc: 'Ég vinn hjá ykkur á staðnum, einn dag í viku eða 24-30 klukkustundir á mánuði - sem leiðtogaþjálfi, teymisþjálfi, vöruþjálfi eða verkefnastjóri.',
        },
      },
    },
    about: {
      title: 'Helgi Guðmundsson',
      intro:
        'Fyrirtækja- og stjórnendaþjálfi, vöruþjálfi, leiðsögumaður og kennari. Ég hef eytt meira en áratug í að vinna með leiðtogum, teymum og fyrirtækjum - fyrst í Svíþjóð, nú á Íslandi.',
      pill1: 'Rannsóknarstuddar aðferðir',
      pill2: 'Hagnýtt - ekki fræðilegt',
      storyTitle: 'Hvað ég geri og hvers vegna',
      storyP1:
        'Ég hef starfað sem lóðs og teymis- & leiðtogaþjálfi í yfir tíu ár - með þau forréttindi að styðja og þjálfa hundruði leiðtoga og teyma víðsvegar um Norðurlönd og á Íslandi, kennt við IHM Business School í Gautaborg og þjálfað yfir níutíu alþjóðlega leiðbeinendur á vottuðum námskeiðum í starfi mínu sem Director of Facilitator Experience hjá Agile People.',
      storyP2:
        'Bakgrunnur minn er í vinnu- og fyrirtækjasálfræði frá Háskólanum í Gautaborg, með aukinni sérhæfingu í lausn ágreininga og sáttamiðlun, auk ICF ACC-vottunar í markþjálfun. Ég er einnig meðhöfundur tveggja kafla í bókinni Agile People Principles sem kom út árið 2021.',
      storyP3:
        'Nálgun mín er þverfagleg að eðlisfari – ég dreg innsýn úr vinnusálfræði, atferlisfræði, kerfishugsun og agile/lean vinnubrögðum, því þær áskoranir sem við þurfum að tækla í dag falla sjaldan snyrtilega í einn ramma. Ég legg líka mikið upp úr að nota gagnreyndar aðferðir, þ.e. byggja á rannsóknum og því sem er sannreynt - sem þýðir stundum að t.d segja fólki að nálgunin á endurgjöf sem það hefur notað árum saman virki í raun gegn hvernig heilinn lærir og þróast. Þær samræður ganga merkilegt nokk yfirleitt alveg ágætlega.',
      publicationLabel: 'Rit',
      publication: {
        title: 'Agile People Principles',
        subtitle: 'Your Call to Action for the Future of Work - útgefin 2021',
        chapters:
          'Meðhöfundur kafla um „Appreciative Feedback" og „Emergent Strategy"',
      },
      credentialsTitle: 'Vottanir og þjálfun',
      timelineTitle: 'Ferilskrá í stuttu máli',
      timeline: [
        {
          year: '2006–2013',
          title: 'Viðskipti, sala og nám',
          desc: 'Viðskiptafræði og alþjóðaviðskipti frá HR. Síðan sala og markaðsetning hjá Póstinum. Flutti til Svíþjóðar haust 2011 og hóf nám í vinnusálfræði í Gautaborg.',
        },
        {
          year: '2013–2017',
          title: 'Vinnu- og fyrirtækjasálfræði',
          desc: 'Fil.Cand. frá Gautaborgarháskóla. Sérhæfð þjálfun í úrlausn ágreininga og lóðsun. ICF ACC markþjálfun hjá Gothia Academy.',
        },
        {
          year: '2017–2022',
          title: 'Alþjóðleg þjálfun og kennsla',
          desc: 'Founder Institute Gautaborg, Global Coach hjá Egencia (Expedia Group), Director of Facilitator Experience hjá Agile People - þjálfaði ~90 alþjóðlega leiðbeinendur og var meðhöfundur ICAgile námskeiðs.',
        },
        {
          year: '2021–2023',
          title: 'Stundakennari - IHM Gautaborg',
          desc: '10 vikna stafrænt námskeið í nútíma vöruþróun. Vendikennsla - innspilað efni og verklegar vinnustofur.',
        },
        {
          year: '2022–',
          title: 'Orgz ehf - Ísland',
          desc: 'Stofnaði eigið fyrirtæki. Þjálfun og ráðgjöf fyrir leiðtoga og teymi - námskeið í nútíma vöruþróun, conflict coaching og lóðsun.',
        },
      ],
      writingLabel: 'Skrif og þankar',
      writingTitle: 'Hvað ég er að hugsa um',
      writingSubtitle:
        'Greinar og kaflar þar sem ég fer yfir hvað rannsóknir segja í raun - og hvað við gerum oft öfugt.',
      outsideWork:
        'Utan vinnu er ég formaður Tangófélags Reykjavíkur, í námi í leiðsögu og ökuleiðsögn - og reyni að gera mig fúsari í að dansa en í að halda fyrirlestra. Gengur misjafnlega.',
    },
    services: {
      title: 'Námskeið, vinnustofur og þjálfun',
      titleHighlight: 'fyrir leiðtoga og teymi',
      subtitle:
        'Fyrir leiðtoga og teymi sem vilja hagnýttar, rannsóknarstuddar aðferðir - ekki loforð um þróun án þess að skilja hvað þarf að breytast.',
      challengesTitle: 'Hvað ég vinn með',
      challengesSubtitle:
        'Veldu þá áskorun sem líkist því sem þú ert að glíma við og skoðaðu hvernig við getum unnið saman að henni.',
      challenge1Title: 'Nýr stjórnandi',
      challenge1Subtitle: 'Leiðtogafærni',
      challenge1Desc:
        'Hlutverkið breytist þegar þú verður stjórnandi - það sem gekk sem sérfræðingur er ekki lengur nóg. Við vinnum saman að því að skilja hvað hlutverkið krefst og byggja upp traust í nýju samhengi.',
      challenge2Title: 'Ágreiningur og erfið samtöl',
      challenge2Subtitle: 'Samskipti og teymi',
      challenge2Desc:
        'Flest teymi forðast þær samræður sem mestu máli skipta. Við vinnum með þeim sem vilja skilja hvað er raunverulega í gangi - hvernig má ræða það á uppbyggilegan hátt og eiga betri, heilbrigðari ágreininga',
      challenge3Title: 'Betri fundir og vinnustofur',
      challenge3Subtitle: 'Lóðsun og samstarf',
      challenge3Desc:
        'Vandinn við fundi er sjaldan tæknin - það er hönnunin. Við vinnum með þá sem vilja hanna og leiða fundi og vinnustofur þar sem fólk er virkt og árangur kemur út.',
      challenge4Title: 'Að leiða í flóknum aðstæðum',
      challenge4Subtitle: 'Agile leiðtogafærni',
      challenge4Desc:
        'Þegar langtímaáætlanir falla saman og vandamálin eru ný fremur en þekkt - hvernig leiðum við þá? Við vinnum með stjórnendur og teymi sem þurfa að vinna í óvissu, prófa sig áfram og þróa leiðtogagetu sem virkar í flóknari aðstæðum.',
      formatsTitle: 'Snið og leiðir',
      formatsSubtitle:
        'Námskeið, vinnustofur og fyrirlestrar - veldu það sem hentar stöðunni.',
      seeMore: 'Sjá meira',
      perPackage: '/ pakki',
      bookService: 'Bóka þessa þjónustu',
      moreInfoCta: 'Nánari upplýsingar',
      moreOptions: 'Aðrar leiðir',
      moreOptionsSubtitle:
        'Auk þjálfunar og námskeiða stend ég einnig fyrir vinnustofum og fyrirlestrum',
      items: {
        essentials: {
          title: 'Stjórnandi í Fyrsta Sinn',
          subtitle: 'Fyrir nýja stjórnendur',
          description:
            'Að taka við stjórnunarstöðu í fyrsta sinn er stórt stökk. Þetta sex vikna námskeið hjálpar þér að skilja hvað hlutverkið krefst í raun - og gefur þér verkfæri til að takast á við það með öryggi.',
          features: [
            'Vikuleg 1:1 þjálfunarfundir',
            'Sniðmát fyrir 1:1 og endurgjöf',
            'Stuðningur milli funda',
            'Persónuleg vaxtaráætlun',
          ],
          price: '$1,499',
        },
        conflict: {
          title: 'Heilbrigðir Ágreiningar',
          subtitle: 'Fyrir teymi í spennu',
          description:
            'Ágreiningur er ekki vandinn - forðunin er vandinn. Námskeið og vinnustofur sem hjálpa teymum að tala saman um það sem skiptir máli, þegar það skiptir máli.\n\nEinnig í boði að koma inn sem lóðs þegar ágreiningur er þegar kominn í gang.',
          features: [
            'Námskeið og vinnustofur um krefjandi samtöl',
            'Uppbygging sálfræðilegs öryggis í teymi',
            'Verkfæri til að skilja hvað er raunverulega í gangi',
            'Lóðsun þegar ágreiningur er virkur',
          ],
          price: '$2,500',
        },
        wizardry: {
          title: 'Betri fundir og vinnustofur',
          subtitle: 'Fyrir leiðbeinendur og fundarstjóra',
          description:
            'Flestir hafa sitið í fundum þar sem engar ákvarðanir voru teknar og enginn vissi hvers vegna fundurinn var haldinn. Við vinnum saman að hönnun og leiðsögn funda og vinnustofa sem gefa ástæðu til að mæta.',
          features: [
            'Hönnun og leiðsögn funda og vinnustofa',
            'Tækni til að auka þátttöku og einbeitingu',
            'Aðferðir sem virka jafnt á netinu og á staðnum',
            'Hagnýtar æfingar og endurgjöf',
          ],
          price: '$499',
        },
        agile: {
          title: 'Agile Leiðtogafærni',
          subtitle: 'Fyrir stjórnendur í breytingum',
          description:
            'Agile er ekki ferli - það er nálgun á óvissu og flókinn veruleika. Námskeið sem fjallar um hvað það þýðir í raun að leiða í slíku umhverfi, byggt á rannsóknum um teymi og leiðtogafærni.',
          features: [
            'Grunnhugtök og ramma Agile og Lean',
            'Hlutverk leiðtoga í Agile teymum',
            'Hagnýtar æfingar og dæmisögur',
            'Stuðningur við innleiðingu',
          ],
          price: '$1,899',
        },
      },
      additional: {
        workshops: {
          title: 'Vinnustofur',
          description:
            'Hálfdags- eða heilsdagsvinnustofur á staðnum eða á netinu - um teymisvinnu, samskipti og leiðtogafærni.',
        },
        talks: {
          title: 'Fyrirlestrar',
          description:
            'Fyrirlestrar frá 30 til 90 mínútum - byggðir á rannsóknum, með hlutlægu sjónarmiði á það sem við teljum virka.',
        },
        courses: {
          title: 'Námskeið',
          description:
            'Dýpri þjálfun í sérhæfðum efnum - frá conflict coaching til leiðtogafærni og lóðsunartækni.',
        },
      },
    },
    newToLeadership: {
      badge: 'Leiðtogafærni',
      title: 'Nýr í',
      titleHighlight: 'stjórnunarhlutverkinu',
      intro1:
        'Hlutverkið breytist þegar þú verður stjórnandi - og það gerist oft hraðar en við búumst við. Það sem gerði þig góðan sem sérfræðing hjálpar þér ekki endilega sem stjórnanda. Þekkingin er enn þar, en starfið hefur breyst.',
      intro2:
        'Rannsóknir á hlutverkaskiptum sýna að flestir nýir stjórnendur vanrækja þá þætti sem mestu máli skipta - að byggja traust, setja fram skýrar væntingar og skapa aðstæður þar sem teymið getur starfað vel. Við förum yfir hvað það þýðir í raun.',
      heroCta: 'Hafa samband',
      signsTitle: 'Þetta hljómar kunnuglegt?',
      signs: [
        'Þú ert nýlega orðinn stjórnandi og ert ekki alveg viss um hvað hlutverkið krefst',
        'Þú þarft að veita endurgjöf en ert ekki viss um hvernig það er gert á uppbyggilegan hátt',
        'Þú ert að kenna þér sjálf/ur - án stuðnings eða skipulags',
        'Þú ert duglegur/dug að vinna en teymið er ekki að nýta sér þig eins og þú vonast til',
        'Þú ert að taka yfir teymi þar sem menninging er þegar til staðar',
        'Þú vilt skilja hvernig á að halda góða 1:1 fundi sem skila einhverju',
      ],
      whatWeDoTitle: 'Hvað við vinnum saman að',
      whatWeDoP1:
        'Við skoðum hvað hlutverkið þitt krefst í raun - ekki almælt ráð um leiðtogafærni heldur það sem þín staða krefst. Hvað þarf að breytast? Hvar ertu sterkur? Hvar er gott að þróa sig?',
      whatWeDoP2:
        'Við byggjum á rannsóknum á hlutverkaskiptum og leiðtogaþróun - en við sniðum það að þinni stöðu. Markmið okkar er að þú gangi frá hverri lotu með eitthvað sem þú getur notað strax.',
      whatWeDoItems: [
        'Hlutverk stjórnandans - hvað breytist og hvað heldur áfram',
        'Að byggja traust í nýju samhengi',
        'Hvernig við gefum og þiggjum endurgjöf á gagnlegan hátt',
        'Að halda góða 1:1 fundi',
        'Forgangsröðun og tímastjórnun í nýju hlutverki',
        'Hvernig við sköpum aðstæður þar sem teymið getur starfað vel',
      ],
      waysTitle: 'Hvernig við getum unnið saman að þessu',
      waysSubtitle:
        'Veldu það snið sem hentar best - eða við getum rætt hvað hentar þér.',
      courseLabel: 'Námskeið',
      workshopLabel: 'Vinnustofa',
      talkLabel: 'Fyrirlestur',
      course1Title: 'Stjórnandi í Fyrsta Sinn',
      course1Desc:
        '6 vikna námskeið sem fer yfir allt frá hlutverkaskiptum til teymisuppbyggingar.',
      workshop1Title: 'Stjórnandi og Leiðtogi',
      workshop1Desc:
        'Heilsdagsvinnustofa um leiðtogastíl, hlutverkið og raunverulegar aðstæður.',
      talk1Title: 'Hvað rannsóknirnar segja um leiðtogafærni',
      talk1Desc:
        'Fyrirlestur um hvað við vitum um hvað gerir leiðtoga áhrifaríka - og hvað við höldum ranglega.',
      learnMore: 'Lesa meira',
      ctaTitle: 'Við skulum tala saman',
      ctaDesc:
        'Segðu mér frá stöðunni þinni og við finnum út hvað hentar best.',
      ctaCta: 'Hafa samband',
    },
    conflictAndConversations: {
      badge: 'Samskipti og teymi',
      title: 'Ágreiningur og',
      titleHighlight: 'erfið samtöl',
      subtitle:
        'Erfið samtöl? Kannski. En sjaldnast af þeirri ástæðu sem við höldum.',
      intro1:
        'Ágreiningur er ekki vandinn. Þegar teymi lenda í vanda er ástæðan oftast sú að fólk forðast samtölin sem þyrftu að eiga sér stað - ekki að einhver sé vondur eða hafi rangt fyrir sér.',
      intro2:
        'Rannsóknir sýna að teymi sem ræða viðkvæm mál opinskátt - hver tekur ákvarðanir, hvernig við vinnum saman, hvað er að fara úrskeiðis - ná að jafnaði betri árangri. Sálfræðilegt öryggi er ekki tískuorð heldur mælanlegur þáttur.',
      heroCta: 'Hafa samband',
      signsTitle: 'Kannastu við þetta?',
      signs: [
        'Það er eitthvað sem allir vita en enginn orðar',
        'Fólk er ósammála frammi á gangi, samþykkir allt á fundinum - og fylgir því svo ekki eftir',
        'Einhver í teyminu veldur vandræðum en enginn tekur á því',
        'Á pappírnum er teymið samstíga, en í raun er það sammála um fátt',
        'Fundur eftir fund, og ekkert breytist',
        'Spenna sem allir finna en enginn kemst til botns í',
      ],
      whatWeDoTitle: 'Það sem við vinnum með',
      whatWeDoP1:
        'Við skoðum hvað er í raun í gangi - ekki bara einkennin heldur það sem liggur að baki. Ágreiningur er oft merki um að eitthvað annað þurfi athygli: óljósar væntingar, ólíkar forsendur eða traust sem hefur smám saman molnað.',
      whatWeDoP2:
        'Ég vinn bæði með einstaklingum og teymum - á námskeiðum, í vinnustofum eða með beinni leiðsögn þegar ágreiningurinn er kominn upp á yfirborðið. Nálgunin byggir á aðferðafræði Conflict Coaching og rannsóknum á sálfræðilegu öryggi.',
      whatWeDoItems: [
        'Að átta sig á hvað er að gerast í teyminu',
        'Að gera krefjandi samtöl möguleg',
        'Aðferðafræði Conflict Coaching',
        'Hlustun og spurningar sem opna samtalið í stað þess að loka því',
        'Að byggja upp sálfræðilegt öryggi í teyminu',
        'Að taka á ágreiningi sem er kominn í hnút',
      ],
      waysTitle: 'Hvernig við getum unnið saman',
      waysSubtitle:
        'Námskeið, vinnustofa eða bein leiðsögn - eftir því hvað þarf.',
      courseLabel: 'Námskeið',
      workshopLabel: 'Vinnustofa',
      talkLabel: 'Fyrirlestur',
      course1Title: 'Conflict Coaching',
      course1Desc:
        'Tveggja daga námskeið í aðferðafræði Conflict Coaching, með hléi á milli til að æfa sig.',
      workshop1Title: 'Hvernig teymi virka í raun',
      workshop1Desc:
        'Vinnustofa um gangverk teyma, traust og hvernig búa má til aðstæður þar sem fólk þorir að tala saman.',
      talk1Title: 'Ágreiningur er ekki vandinn',
      talk1Desc:
        'Fyrirlestur um hvað rannsóknir segja um ágreining í teymum - og hvað við getum gert öðruvísi.',
      learnMore: 'Lesa meira',
      ctaTitle: 'Við skulum tala saman',
      ctaDesc: 'Segðu mér frá stöðunni og við finnum saman hvað hentar.',
      ctaCta: 'Hafa samband',
    },
    meetingsAndFacilitation: {
      badge: 'Lóðsun og samstarf',
      title: 'Betri fundir og vinnustofur',
      titleHighlight: 'sem virka í raun',
      intro1:
        'Flestir fundir bregðast ekki vegna þess að fólk er slæmt eða of upptekið. Þeir bregðast vegna þess að þeir eru hannaðir rangt - eða ekki hannaðir yfir höfuð. Það er vandinn sem er hægt að leysa.',
      intro2:
        'Rannsóknir á fundahegðun sýna að meirihluti fundartíma skilar litlum áhrifum. Fólk er á netinu, sárt, eða einbeitt að öðru. Þetta er ekki tilviljun og það er ekki óumflýjanlegt.',
      heroCta: 'Hafa samband',
      signsTitle: 'Þetta hljómar kunnuglegt?',
      signs: [
        'Fundir eru haldnir af vana - enginn er viss um af hverju',
        'Ákvarðanir eru teknar en enginn veit hverjir eru ábyrgir',
        'Fjarfundir þar sem helmingurinn er á netinu og restin er hljóð',
        'Vinnustofur þar sem allir hlusta en enginn tekur þátt',
        'Fundur eftir fund þar sem sömu málefnin koma upp aftur og aftur',
        'Þú leggur mikið á þig en teymið kemur ekki með það sem þú vonast til',
      ],
      whatWeDoTitle: 'Hvað við vinnum saman að',
      whatWeDoP1:
        'Við skoðum hvernig þú hannar og leiðir fundi og vinnustofur - hvort sem þeir eru á netinu eða á staðnum. Vandinn er oft í hönnuninni: hvernig við setjum upp, hvernig við byrjum, hvernig við sköpum rými fyrir raunverulega þátttöku.',
      whatWeDoP2:
        'Við byggjum á aðferðafræðinni "Training from the Back of the Room" og rannsóknum á athygli og þátttöku. Markmið okkar er að þú komir frá þjálfuninni með verkfæri og nálgun sem þú getur notað í næsta fundi.',
      whatWeDoItems: [
        'Hönnun funda og vinnustofa sem skila árangri',
        'Hvernig við sköpum raunverulega þátttöku - á netinu og á staðnum',
        'Tækni og tól sem virka í raun',
        'Hvernig við leiðum umræður sem fara í rétta átt',
        'Fjarfundir sem fólk vill mæta á',
        'Vinnustofur þar sem þátttakendur eru virkir og læra af eigin reynslu',
      ],
      waysTitle: 'Hvernig við getum unnið saman að þessu',
      waysSubtitle: 'Tveggja til fjögurra kosta völ - veldu það sem hentar.',
      courseLabel: 'Námskeið',
      workshopLabel: 'Vinnustofa',
      talkLabel: 'Fyrirlestur',
      course1Title: 'Betri Fjarfundir',
      course1Desc:
        '2 lotur þar sem við förum yfir hönnun og leiðsögn fjarfunda.',
      course2Title: 'Betri Vinnustofur á Netinu',
      course2Desc:
        '3 lotur í hönnun og leiðsögn vinnustofa - með eigin micro-vinnustofu sem æfingu.',
      workshop1Title: 'Árangursríkari Fjarfundir',
      workshop1Desc:
        'Vinnustofa þar sem við æfum bæði hönnun og leiðsögn fjarfunda.',
      talk1Title: 'Vandinn við fundi er hönnunin',
      talk1Desc:
        'Fyrirlestur um hvað rannsóknir segja um hvað gerir fundi áhrifaríka - og hvað við gerum oft öfugt.',
      learnMore: 'Lesa meira',
      ctaTitle: 'Við skulum tala saman',
      ctaDesc:
        'Segðu mér hvaða vandamál þú ert að glíma við og við finnum út hvað hentar.',
      ctaCta: 'Hafa samband',
    },
    leadingInComplexity: {
      badge: 'Agile leiðtogafærni',
      title: 'Að leiða þegar',
      titleHighlight: 'áætlunin brotnar saman',
      intro1:
        'Sumar aðstæður eru flóknar á þann hátt að hefðbundnar aðferðir duga ekki. Þegar vandinn er nýr, þegar umhverfið breytist hratt og þegar enginn veit rétta svarið fyrirfram - þá þarf aðra nálgun en verkefnastjórnun og bestu starfsvenjur.',
      intro2:
        'Cynefin-ramminn og rannsóknir á flóknum kerfum sýna að þessar aðstæður þarfnast annars konar leiðtogaháttarins: meira sköpunargáfu, meiri tilraunastarfsemi, minni yfirlýst vissu. Það þýðir ekki að vera villtur - það þýðir að vera meðvitaður um hvers konar vandamáli þú ert að fást við.',
      heroCta: 'Hafa samband',
      signsTitle: 'Þetta hljómar kunnuglegt?',
      signs: [
        'Langtímaáætlanir eru búnar til en verða úreltar áður en þær eru framkvæmdar',
        'Teymið er að vinna að vandamáli sem hefur aldrei verið leyst áður',
        'Bestu starfsvenjur ganga ekki upp í þínum samhengi',
        'Þú þarft að taka ákvarðanir með ófullnægjandi upplýsingum',
        'Skipulagið er of stíft fyrir það sem raunverulegan áskoranir krefst',
        'Þú þarft að ná teyminu með þér í óvissu - án þess að þykjast vita allt',
      ],
      whatWeDoTitle: 'Hvað við vinnum saman að',
      whatWeDoP1:
        'Við skoðum hvernig leiðtogafærni lítur út þegar vandinn er flókinn - ekki tæknilegur eða flókinn á hefðbundinn hátt. Hvað þýðir það að skapa skilyrði þar sem teymið getur lært og aðlagað sig? Hvernig tilraunumst við okkur áfram á skipulagðan hátt?',
      whatWeDoP2:
        'Við byggjum á Agile og Lean hugmyndafræðinni, Cynefin-rammanum og rannsóknum á teymum sem vinna í óvissunni. Þetta er ekki Agile sem ferli heldur Agile sem hugarfar og leið til að leiða.',
      whatWeDoItems: [
        'Cynefin-ramminn - hvers konar vandamáli ert þú að fást við?',
        'Hvernig við sköpum aðstæður þar sem teymið getur tilraunað sig áfram',
        'Ákvörðunartaka í óvissu án þess að þykjast vita allt',
        'Agile og Lean sem leið til að leiða - ekki sem ferli',
        'Hvernig við hlustum á veiku merkin í umhverfinu',
        'Leiðtogahlutverk í teymum sem eru að þróast',
      ],
      waysTitle: 'Hvernig við getum unnið saman að þessu',
      waysSubtitle:
        'Námskeið, vinnustofa eða fyrirlestur - eftir því hvað hentar.',
      courseLabel: 'Námskeið',
      workshopLabel: 'Vinnustofa',
      talkLabel: 'Fyrirlestur',
      course1Title: 'Agile Leiðtogafærni',
      course1Desc:
        'Námskeið sem fer yfir Agile og Lean sem leiðtogafærni - ekki sem verkefnastjórnunarlíkan.',
      workshop1Title: 'Stjórnandi og Leiðtogi',
      workshop1Desc:
        'Vinnustofa þar sem við skoðum leiðtogastíl í flóknum aðstæðum.',
      talk1Title: 'Að leiða í flóknum heimi',
      talk1Desc:
        'Fyrirlestur um Cynefin, flókin kerfi og hvað það þýðir að leiða þegar vandinn er nýr.',
      learnMore: 'Lesa meira',
      ctaTitle: 'Við skulum tala saman',
      ctaDesc: 'Segðu mér frá stöðunni og við skoðum hvað myndi gagnast mest.',
      ctaCta: 'Hafa samband',
    },
    coaching: {
      badge: 'Einstaklingsþjálfun',
      title: 'Þjálfun sem',
      titleHighlight: 'hentar þinni stöðu',
      intro1:
        'Einstaklingsþjálfun þýðir að við tökum þína stöðu alvarlega - ekki almælt ráð heldur samtal um það sem þú ert að glíma við í raun. Hvert viðtal byggir á því sem kom á undan og fer þangað sem vandinn er.',
      intro2:
        'Við byrjum alltaf á uppgötvunarspjalli - ókeypis og án skuldbindingar. Þar skoðum við hvað þú ert að glíma við og hvort þjálfun sé rétta leiðin. Ef við höldum áfram er það á forsendum sem passa þér.',
      heroCta: 'Bóka uppgötvunarspjall',
      signsTitle: 'Hvenær hentar einstaklingsþjálfun?',
      signs: [
        'Þú ert í nýju hlutverki og þarft stuðning sem er sniðinn að þinni stöðu',
        'Þú ert að glíma við áskorun sem krefst meira en námskeið getur gefið',
        'Þú vilt vinna í gegnum eitthvað á þínum hraða - með raunverulegan stuðning',
        'Þú þarft einhvern sem getur spegla þig og sett fram erfiðar spurningar',
        'Þú ert að þróa þig sem leiðtogi og vilt gera það á meðvitaðan hátt',
        'Þú hefur reynt almælt ráð og það hefur ekki skilað sér',
      ],
      whatWeDoTitle: 'Hvernig þjálfunin virkar',
      whatWeDoP1:
        'Við mætumst reglulega - yfirleitt einu sinni í viku eða aðra hverja viku. Við byrjum á því að skilja hvar þú ert og hvað þú vilt vinna að. Síðan byggjum við á því í hvert sinn.',
      whatWeDoP2:
        'Ég er þjálfi, ekki ráðgjafi. Það þýðir að ég spyr, spegla og ögra - en þú tekur ákvarðanirnar. Markmið mitt er að þú komist betur til skila með hvað þú ert að gera og hvers vegna.',
      whatWeDoItems: [
        'Uppgötvunarspjall til að skilja hvað þú þarft',
        'Reglulegar lotur - á þínum hraða',
        'Samtöl sem fara þangað sem vandinn er',
        'Hagnýtar æfingar og ígrundun á milli lota',
        'Endurgjöf sem er bæði heiðarleg og uppbyggileg',
        'Niðurstaða sem er þín - ekki mín',
      ],
      relatedTitle: 'Hvað gætum við unnið saman að?',
      relatedSubtitle: 'Einstaklingsþjálfun hentar vel fyrir þessar áskoranir:',
      rel1Title: 'Nýr í stjórnunarhlutverkinu',
      rel1Desc: 'Hlutverkið breytist - við getum unnið saman að því.',
      rel2Title: 'Ágreiningur og erfið samtöl',
      rel2Desc: 'Hvernig við tökum á því sem er erfitt að ræða.',
      rel3Title: 'Að leiða í flóknum aðstæðum',
      rel3Desc: 'Leiðtogafærni þegar vandinn er nýr.',
      learnMore: 'Lesa meira',
      ctaTitle: 'Byrjum á spjalli',
      ctaDesc:
        'Uppgötvunarspjall er ókeypis og án skuldbindingar. Við skoðum saman hvort þjálfun sé rétta leiðin.',
      ctaCta: 'Bóka uppgötvunarspjall',
    },
    embeddedPartner: {
      badge: 'Innbyggður sérfræðingur',
      title: 'Sérfræðingur á staðnum',
      titleHighlight: 'einn dag í viku',
      intro1:
        'Stundum þurfa fyrirtæki ekki fullt starf - heldur réttan mann á réttan tíma. Ég get verið hjá ykkur á staðnum, einn dag í viku eða 24-30 klukkustundir á mánuði, og unnið sem hluti af teyminu ykkar.',
      intro2:
        'Við byrjum alltaf á uppgötvunarspjalli þar sem við skoðum hvað þið þurfið og hvort þetta form hentar. Ef við höldum áfram er samstarfið mótað að þörfum ykkar.',
      heroCta: 'Hafa samband',
      detail1Title: 'Tímasetning',
      detail1Desc:
        'Einn dagur í viku eða 24-30 klukkustundir á mánuði - eftir því hvað hentar.',
      detail2Title: 'Vinnulag',
      detail2Desc:
        'Á staðnum hjá ykkur - sem hluti af teyminu, ekki utanaðkomandi ráðgjafi.',
      detail3Title: 'Upphaf',
      detail3Desc:
        'Við byrjum alltaf á uppgötvunarspjalli - ókeypis og án skuldbindingar.',
      signsTitle: 'Hvenær hentar þetta?',
      signs: [
        'Þið þurfið sérfræðiþekkingu en ekki fullt starf',
        'Þið eruð í uppbyggingu og þurfið stuðning á tilteknu sviði um tíma',
        'Þið viljið fá inn utanaðkomandi sjónarhorn - en með raunverulega þekkingu á ykkar samhengi',
        'Þið eruð að innleiða breytingar og þurfið einhvern til að lóðsa ferlið',
        'Leiðtogi eða teymi þarf reglulegan stuðning sem er meira en námskeið',
        'Þið eruð of lítil til að réttlæta fasta ráðningu en þurfið þekkinguna',
      ],
      rolesTitle: 'Hvað ég get verið hjá ykkur',
      rolesSubtitle: 'Hlutverkið ræðst af þörfum ykkar - ekki af starfstitli.',
      roles: [
        'Leiðtogaþjálfi - stuðningur við stjórnendur og leiðtoga',
        'Teymisþjálfi - vinna með teymið á aðferðafræðilegan hátt',
        'Vöruþjálfi - stuðningur við vörustjórnun og vöruþróun',
        'Verkefnastjóri - leiðsögn á tilteknum verkefnum',
        'Agile Coach - innleiðing á Agile og Lean starfsvenjum',
        'Lóðsari - leiðsögn á fundum, vinnustofum og ákvarðanatökuferlum',
      ],
      whatWeDoTitle: 'Hvernig samstarfið virkar',
      whatWeDoP1:
        'Við byrjum á uppgötvunarspjalli þar sem við skoðum hvað þið þurfið, hvenær og hvers vegna. Þar skoðum við líka hvort ég er réttur maður fyrir verkið.',
      whatWeDoP2:
        'Ef við höldum áfram er samstarfið mótað að þörfum ykkar - hlutverkið, tímasetningin og markmið samstarfsins. Við gerum upp á milli mánaðarlega.',
      whatWeDoItems: [
        'Uppgötvunarspjall til að skilja þörfir',
        'Mótað samstarf - ekki pakkaþjónusta',
        'Á staðnum - sem hluti af teyminu',
        'Reglulegar uppgjör og endurgjöf',
        'Sveigjanleg tímasetning eftir þörfum',
        'Hægt að stækka eða minnka samstarfið',
      ],
      ctaTitle: 'Við skulum kynna okkur',
      ctaDesc:
        'Uppgötvunarspjall er ókeypis og án skuldbindingar. Við skoðum saman hvort þetta hentar.',
      ctaCta: 'Hafa samband',
    },
    courses: {
      badge: 'Námskeið',
      title: 'Námskeið fyrir leiðtoga og teymi',
      subtitle:
        'Hagnýt þjálfun byggð á rannsóknum - ekki almenn ráðgjöf. Veldu það námskeið sem hentar stöðunni.',
      benefitsTitle: 'Hvað þú færð út úr námskeiðinu:',
      moreInfo: 'Meiri upplýsingar',
      customTitle: 'Þarftu eitthvað sérsniðið?',
      customDescription:
        'Ég hanna og held einnig námskeið innanhúss hjá fyrirtækjum - aðlagað að ykkar samhengi og þörfum.',
      contactUs: 'Hafa samband',
      additional: {
        title: 'Fleiri námskeið',
        subtitle:
          'Sérhæfð námskeið fyrir þá sem vilja dýpka sig í ákveðið svið.',
        artOfFacilitation: {
          title: 'Listin að Lóðsa',
          subtitle: 'Sérhæfð þjálfun í lóðsun',
          desc: 'Námskeið fyrir þá sem vilja þróa lóðsun sem faglega færni - ekki bara betri fundi, heldur skilning á lóðsun sem aðferðafræði.',
        },
      },
      items: {
        conflictCoaching: {
          title: 'Conflict Coaching',
          subtitle: 'Betri samskipti og heilbrigðari ágreiningar',
          description:
            'Ágreiningur er óhjákvæmilegur - en hvernig við tökum á honum er annað mál. Þetta námskeið gefur þér verkfæri til að leiða krefjandi samtöl og skilja hvað gerist í raun þegar fólk er ósammála.',
          duration: '2 dagar (með millibili)',
          format: 'Staðnámskeið eða stafrænt',
          audience: 'Stjórnendur, teymi, HR fagfólk',
          benefits: [
            'Skilningur á eðli ágreininga og hvernig þeir þróast',
            'Aðferðir til að kortleggja hvað er raunverulega í gangi',
            'Þjálfun í hlustun og samtalstækni',
            'Aukið sjálfstraust í erfiðum samtölum',
          ],
        },
        firstTimeManager: {
          title: 'Stjórnandi í Fyrsta Sinn',
          subtitle: 'Uppbygging í nýju hlutverki',
          description:
            'Hlutverkið breytist þegar þú verður stjórnandi - það sem gekk sem sérfræðingur dugar ekki lengur. Þetta námskeið hjálpar þér að skilja hvað breytist og gefur þér verkfærin til að takast á við það.',
          duration: '6 vikur (ein lota á viku)',
          format: 'Staðnámskeið eða stafrænt',
          audience: 'Nýir stjórnendur, verðandi stjórnendur',
          benefits: [
            'Skýrari sýn á hvað hlutverkið krefst',
            'Verkfæri til að veita og þiggja endurgjöf',
            'Aðferðir til að forgangsraða og stýra tíma',
            'Skilningur á hvernig teymi þróast',
          ],
        },
        betterOnlineMeetings: {
          title: 'Betri Fjarfundir',
          subtitle: 'Fundir á netinu sem skila árangri',
          description:
            'Fjarfundir eru ekki vandinn - lélegar venjur eru vandinn. Þetta námskeið fer yfir hvað rannsóknir segja um athygli, þátttöku og uppbyggingu funda - og hvað þú getur gert öðruvísi.',
          duration: '2 x 2 klukkustundir',
          format: 'Stafrænt',
          audience: 'Allir sem leiða fundi á netinu',
          benefits: [
            'Aukin þátttaka og einbeiting á fundum',
            'Tækni og tól sem virka í raun',
            'Aðferðir til að skapa öruggt rými á netinu',
            'Skilvirkari ákvarðanataka',
          ],
        },
        betterOnlineWorkshops: {
          title: 'Betri Vinnustofur á Netinu',
          subtitle: 'Hönnun og leiðsögn vinnustofa',
          description:
            'Að flytja vinnustofu yfir á Zoom er ekki sama og að leiða góða vinnustofu á netinu. Þetta námskeið fer yfir hvernig við hönnumst vinnustofur þar sem fólk er virkt og lærir af eigin reynslu.',
          duration: '3 lotur (3 x 2-3 klst)',
          format: 'Stafrænt',
          audience: 'Leiðbeinendur, þjálfarar, kennarar',
          benefits: [
            'Training from the Back of the Room aðferðafræði',
            'Hönnun gagnvirkra æfinga',
            'Æfing í að flytja eigin vinnustofu',
            'Endurgjöf frá jafningjum og leiðbeinanda',
          ],
        },
        modernProductManagement: {
          title: 'Nútíma Vörustjórnun',
          subtitle: 'Frá hugmynd að árangursríkri vöru',
          description:
            'Vörustjórnun hefur þróast. Þetta námskeið fer yfir hvað það þýðir í raun - frá grunnhugtökum og algengum ramma til hagnýtra verkfæra og AI-studdrar prótótýpugerðar.',
          duration: '½ - 2 dagar',
          format: 'Staðnámskeið eða stafrænt',
          audience: 'Vörustjórar og verkefnastjórar',
          benefits: [
            'Skilningur á hlutverki vörustjórans í dag',
            'Algeng módel: Lean, Agile, Jobs-to-be-Done',
            'Verkfæri til að skilja notendur og markaðinn',
            'Forgangsröðun og ákvarðanataka í vöruþróun',
            'Hagnýtar æfingar og raunveruleg dæmi',
            'AI verkfæri í prótótýpugerð',
          ],
          formatToggle: {
            inPerson: 'Á staðnum',
            digital: 'Stafrænt (Vendikennsla)',
          },
          inPersonTiers: {
            tier1: {
              name: 'Grunnur',
              duration: '½ dagur',
              subtitle: 'Vörustjórnun 101',
              description: 'Fullkomin kynning á vörustjórnun.',
              features: [
                'Hvað er vörustjórnun?',
                'Hlutverk vörustjórans',
                'Grunnhugtök og orðaforði',
                'Yfirlit yfir vöruþróunarferlið',
                'Dæmi úr raunveruleikanum',
              ],
            },
            tier2: {
              name: 'Viðbót',
              duration: '1 dagur',
              subtitle: 'Módel og Verkfæri',
              description: 'Grunnurinn plús algeng módel og verkfæri.',
              features: [
                'Allt úr Grunni',
                'Lean Startup aðferðafræði',
                'Jobs-to-be-Done rammi',
                'Forgangsröðunarverkfæri (RICE, MoSCoW)',
                'Notendaviðtöl og rannsóknir',
                'Roadmap og áætlanagerð',
              ],
              highlighted: true,
            },
            tier3: {
              name: 'Heildstætt',
              duration: '2 dagar',
              subtitle: 'Verkleg Þjálfun + AI',
              description: 'Ítarleg þjálfun með AI verkfærum.',
              features: [
                'Allt úr Viðbót',
                'Verklegar æfingar í hópum',
                'Þróun eigin vöruhugmyndar',
                'AI verkfæri fyrir prótótýpur',
                'Frá hugmynd að MVP',
                'Kynning og endurgjöf',
              ],
            },
          },
          digitalTiers: {
            tier1: {
              name: 'Grunnur',
              sessions: '1x 2.5 klst',
              subtitle: 'Vörustjórnun 101',
              description: 'Ein gagnvirk vinnustofa um grunnhugtök.',
              features: [
                'Hvað er vörustjórnun?',
                'Hlutverk vörustjórans',
                'Grunnhugtök og orðaforði',
                'Gagnvirkar umræður',
                'Kennslumyndbönd til undirbúnings',
              ],
            },
            tier2: {
              name: 'Viðbót',
              sessions: '3x 2.5 klst',
              subtitle: 'Módel og Verkfæri',
              description: 'Þrjár vinnustofur sem fara dýpra í módel.',
              features: [
                'Allt úr Grunni',
                'Lean og Agile aðferðir',
                'Forgangsröðunarverkfæri',
                'Notendarannsóknir',
                'Æfingar milli lota',
                'Kennslumyndbönd fyrir hverja lotu',
              ],
              highlighted: true,
            },
            tier3: {
              name: 'Heildstætt',
              sessions: '6x 2.5 klst',
              subtitle: 'Verkleg Þjálfun + AI',
              description: 'Sex vinnustofur með AI-studdri prótótýpugerð.',
              features: [
                'Allt úr Viðbót',
                'Verklegar æfingar',
                'Eigin vöruhugmynd þróuð',
                'AI verkfæri kynnt og notuð',
                'Hópavinna og endurgjöf',
                'Kynning á lokaverkefni',
              ],
            },
          },
          digitalNote:
            'Stafræna námskeiðið notar vendikennslu (flipped learning). Þátttakendur horfa á kennslumyndbönd heima og taka síðan þátt í gagnvirkum vinnustofum í gegnum Zoom.',
          forWhom: 'Fyrir hvern?',
          forWhomItems: [
            'Vörustjórar sem vilja styrkja grunninn',
            'Verkefnastjórar sem vilja skilja vörustjórnun',
            'Stofnendur og frumkvöðlar',
            'Hönnuðir og þróunaraðilar sem vinna með vörustjórum',
          ],
          inquiry: 'Fyrirspurn',
          groupTitle: 'Hópafsláttur?',
          groupDesc:
            'Eruð þið fleiri úr sama fyrirtæki? Ég býð upp á sérstök kjör.',
          contactLink: 'Hafa samband',
          ctaTitle: 'Taktu skrefið í átt að betri vörustjórnun',
          ctaDesc: 'Veldu það snið sem hentar þér og byrjaðu ferðina.',
          ctaCta: 'Hafa samband',
        },
      },
    },
    artOfFacilitation: {
      badge: 'Sérhæfð þjálfun',
      title: 'Listin að Lóðsa',
      titleHighlight: 'Lóðsun sem fagleg færni',
      audienceNote:
        'Fyrir þá sem vilja skilja lóðsun á dýpri máta - ekki bara betri fundi.',
      aboutP1:
        'Þetta námskeið er fyrir þá sem vilja þróa lóðsun sem faglega færni. Við förum yfir hvað lóðsun þýðir í raun - hvernig við sköpum aðstæður þar sem hópur getur unnið saman á áhrifaríkan hátt, hvort sem um er að ræða fundi, vinnustofur eða flóknari ferla.',
      aboutP2:
        'Lóðsun er ekki um að vera hlutlægur - það er um að vera meðvitaður um áhrif sín og nota þau af ásetningi. Við byggjum á rannsóknum á hópadynamík, þátttöku og námi.',
      duration: '2-3 dagar (hægt að skipta upp)',
      format: 'Staðnámskeið eða stafrænt',
      audience: 'Lóðsarar, þjálfarar, HR fagfólk, stjórnendur sem leiða mikið',
      bookCta: 'Hafa samband',
      learnTitle: 'Hvað þú lærir',
      benefits: [
        'Hvað lóðsun þýðir - og hvað hún þýðir ekki',
        'Hvernig við sköpum aðstæður þar sem hópur getur unnið saman',
        'Mismunandi lóðsunarlíkön og hvenær á að nota þau',
        'Hlutlægni og hlutdrægni - og hvernig við stjórnum báðum',
        'Hvernig við tökum á erfiðum hópdynamík',
        'Hönnun ferla sem skila árangri',
        'Hvernig við lesumst á hópinn og breytur undir ferli',
      ],
      forWhom: 'Fyrir hvern?',
      forWhomItems: [
        'Þeir sem leiða mikið - fundir, vinnustofur, ráðgjöf',
        'HR fagfólk og breytingastjórar',
        'Þjálfarar og ráðgjafar',
        'Stjórnendur sem vilja þróa lóðsunartækni',
      ],
      structureTitle: 'Uppbygging',
      curriculum: [
        {
          day: 'Dagur 1',
          title: 'Grunnurinn - Hvað er lóðsun?',
          topics: [
            'Lóðsun sem hlutverki og hugarfar',
            'Mismunandi gerðir af lóðsun',
            'Hópdynamík og hvernig við berum okkur að',
            'Hlustun sem tækni',
          ],
        },
        {
          day: 'Dagur 2',
          title: 'Í aðgerð - Ferlar og aðferðir',
          topics: [
            'Hönnun lóðsunarlota',
            'Mismunandi lóðsunarlíkön',
            'Að takast á við erfiðar aðstæður',
            'Æfingar og endurgjöf',
          ],
        },
        {
          day: 'Dagur 3 (valfrjáls)',
          title: 'Dýpri vinna og ígrundun',
          topics: [
            'Lóðsunarsýn og gildi',
            'Hvernig við þróum okkur sem lóðsarar',
            'Endurgjöf á eigin lóðsunarstíl',
            'Næstu skref og þróunaráætlun',
          ],
        },
      ],
      ctaTitle: 'Við skulum tala saman',
      ctaDesc: 'Segðu mér frá þörfum þínum og við finnum út hvað hentar best.',
      ctaCta: 'Hafa samband',
    },
    workshops: {
      badge: 'Vinnustofur',
      title: 'Vinnustofur fyrir',
      titleHighlight: 'leiðtoga og teymi',
      subtitle:
        'Hálfdags- eða heilsdagsvinnustofur á staðnum eða á netinu - þar sem við förum yfir það sem skiptir máli, ekki það sem lítur vel út.',
      inPersonTitle: 'Á Staðnum',
      inPersonSubtitle: 'Við hittumst og vinnum saman - augliti til auglis',
      onlineTitle: 'Á Netinu',
      onlineSubtitle: 'Lifandi vinnustofur með leiðsögn - ekki bara glærur',
      getQuote: 'Fá tilboð',
      customTitle: 'Þarftu eitthvað sérsniðið?',
      customDescription:
        'Ég hanna vinnustofur eftir þörfum - hvort sem þetta er fyrir lítið teymi eða stóran hóp. Við getum rætt hvað myndi gagnast mest.',
      customCta: 'Við skulum ræða saman',
      items: {
        teamDynamics: {
          title: 'Hvernig teymi virka',
          subtitle: 'Vinnustofa um teymisvinnu og samskipti',
          description:
            'Rannsóknir sýna að flestir hafa meiri slæma reynslu af teymisvinnu en góða - og það er ekki tilviljun. Þessi vinnustofa fer yfir hvað rannsóknir segja um hvernig öflug teymi þróast, hvernig traust myndast og hvernig samskiptamunur verður styrkur frekar en friksíó.',
          duration: 'Hálfur dagur (3-4 klst) eða heill dagur (6-8 klst)',
          format: 'Á staðnum hjá þér eða á fundarstað',
          benefits: [
            'Skilningur á hvernig teymi þróast samkvæmt rannsóknum',
            'Raunverulegar æfingar - ekki hlutverkaleikir í tómarúmi',
            'Hagnýtt samtal um þitt teymi og þínar aðstæður',
            'Aðgerðaáætlun til að taka með heim',
          ],
        },
        leadershipIntensive: {
          title: 'Stjórnandi og Leiðtogi',
          subtitle: 'Fyrir nýja og reynda stjórnendur',
          description:
            'Stjórnandinn og leiðtoginn eru ekki alltaf sama persónan - og þarf ekki að vera. Þessi vinnustofa hjálpar þér að skilja hvað hlutverkið krefst í raun, hvar þú ert sterkur og hvar er gott að þróa sig frekar.',
          duration: 'Heilur dagur (8 klst)',
          format: 'Á staðnum, hámark 12 þátttakendur',
          benefits: [
            'Greining á eigin leiðtogastíl - byggt á gögnum',
            'Hagnýt umræða um raunveruleg tilvik',
            'Verkfæri sem nýtast í daglegri stjórnun',
            'Samtal við aðra stjórnendur í svipaðri stöðu',
          ],
        },
        virtualFacilitation: {
          title: 'Betri Fjarfundir',
          subtitle: 'Fjarfundir sem fólk vill mæta á',
          description:
            'Vandinn við fjarfundi er sjaldan tæknin - það er hönnunin. Þessi vinnustofa fer yfir hvernig við hönnumst fundi sem halda athygli, skapa þátttöku og skila skýrum niðurstöðum - í gegnum skjáinn.',
          duration: '2 x 2 klukkustundir (tvær lotur)',
          format: 'Lifandi á netinu með hagnýtum æfingum',
          benefits: [
            'Tækni og tól sem virka í raun',
            'Aðferðir til að skapa þátttöku á netinu',
            'Æfing í öruggu umhverfi með endurgjöf',
            'Efni til að taka með og nota strax',
          ],
        },
        remoteTeam: {
          title: 'Fjarteymi sem Virkar',
          subtitle: 'Uppbygging teymismenningar á fjarlægð',
          description:
            'Fjarteymi þarfnast meðvitaðrar uppbyggingar - það gerist ekki sjálfkrafa. Þessi vinnustofa fer yfir hvernig við sköpum traust, samskiptanormar og tengingu þegar teymið er dreift.',
          duration: 'Hálfur dagur (4 klst)',
          format: 'Lifandi á netinu með hópavinnurýmum',
          benefits: [
            'Samskiptanormar sem teymið setur sjálft',
            'Verkfæri til að viðhalda tengingu á fjarlægð',
            'Aðferðir til að byggja traust þegar við hittumst sjaldan',
            'Sniðmát og gátlistar til að nota',
          ],
        },
      },
    },
    talks: {
      badge: 'Fyrirlestrar',
      title: 'Hugmyndir sem',
      titleHighlight: 'vekja til umhugsunar',
      subtitle:
        'Fyrirlestrar byggðir á rannsóknum og reynslu - ekki almælt hvatningarefni. Efnið kemur úr því sem ég skrifa um og kenn.',
      chooseTitle: 'Þrjár leiðir',
      chooseSubtitle:
        'Mismunandi snið eftir þörfum viðburðarins - frá stuttri kveikju til vinnustofunnar',
      idealFor: 'Hentar vel fyrir:',
      topicsLabel: 'Mögulegt efni',
      formatLabel: 'Uppbygging',
      bookTalk: 'Bóka þennan fyrirlestur',
      popularTopics: 'Efni sem ég tala um',
      popularTopicsSubtitle:
        'Öll efni byggð á rannsóknum og raunverulegri reynslu - ekki almælt hvatningarefni',
      customTitle: 'Annað efni í huga?',
      customDescription:
        'Ég aðlaga gjarnan fyrirlestur að þörfum viðburðarins. Við getum rætt hvað myndi henta best.',
      customCta: 'Hafðu samband',
      items: {
        short: {
          title: 'Kveikjan',
          duration: '30-40 mínútur',
          subtitle: 'Ein hugmynd - þétt og beint',
          description:
            'Ein hugmynd sem fólk hugsar um eftir að það fer heim. Hentar þegar tíminn er stuttur en við viljum skilja eftir eitthvað sem þýðir.',
          idealFor:
            'Opnun viðburðar, hádegisfyrirlestur, hlé í dagslöngu þjálfunardegi',
          topics: [
            'Endurgjöf sem virkar - og endurgjöf sem virkar ekki',
            'Hvers vegna flestir hafa aldrei upplifað gott teymi',
            'Vandinn við „uppbyggilega gagnrýni"',
            'Hvernig við lærum í raun',
          ],
          format: [
            '25 mín fyrirlestur + 5 mín spurningar',
            'Ein lykilhugmynd - ein skýr niðurstaða',
            'Gagnvirkt ef tíminn leyfir',
          ],
        },
        standard: {
          title: 'Málið',
          duration: '60 mínútur',
          subtitle: 'Heila rökstuðningurinn',
          description:
            'Tími til að fara í gegnum efnið eins og það á skilið. Rök, gögn, dæmi úr raunveruleikanum og eitthvað sem fólk getur tekið með sér.',
          idealFor: 'Ráðstefnur, ársfundir, fagdagar, fyrirtækjaviðburðir',
          topics: [
            'Hvernig öflug teymi þróast - og hvers vegna flest gera það ekki',
            'Leiðtogar sem skipta máli - hvað rannsóknirnar segja',
            'Sálfræðilegt öryggi: hvað það er og hvað það er ekki',
            'Endurgjöf, traust og samskipti á vinnustað',
            'Agile sem hugarfar - ekki sem ferli',
          ],
          format: [
            '45-50 mín fyrirlestur + 10-15 mín spurningar',
            'Raunveruleg dæmi og rannsóknarniðurstöður',
            'Hagnýtar ábendingar til að taka með',
          ],
        },
        deepDive: {
          title: 'Fundurinn',
          duration: '90 mínútur',
          subtitle: 'Við förum í gegnum þetta saman',
          description:
            'Meira en fyrirlestur - við vinnum með efnið saman. Hentar þegar við viljum ekki bara ræða hugmyndirnar heldur líka prófa þær og sjá hvernig þær eiga við.',
          idealFor:
            'Leiðtogadagar, þróunardagar, minni hópar sem vilja dýpka skilning',
          topics: [
            'Conflict Coaching - hvernig við tökum á ágreiningi',
            'Hvernig teymi þróast: Tuckman, Wheelan og hvað rannsóknirnar segja',
            'Leiðtoginn í breytingum - hvað það þýðir að leiða í flókinni stöðu',
            'Endurgjöf sem lærir fólk eitthvað',
          ],
          format: [
            '50-60 mín fyrirlestur + 20-25 mín æfingar + umræður',
            'Smærri hópaæfingar - við reynum á efnið',
            'Opnar spurningar og dýpri umræður',
            'Eitthvað til að taka með heim',
          ],
        },
      },
      topicsList: {
        leadership: {
          title: 'Leiðtogafærni',
          description:
            'Hvað rannsóknirnar segja um hvað gerir leiðtoga áhrifaríka - og hvað við teljum ranglega að geri það',
        },
        teams: {
          title: 'Hvernig teymi þróast',
          description:
            'Tuckman, Wheelan og aðrar rannsóknir á því hvernig hópar verða að teymum - eða gera það ekki',
        },
        agile: {
          title: 'Agile og Lean hugarfar',
          description:
            'Hvað það þýðir að vinna á agile hátt þegar umhverfið er flókið og kröfurnar breytast',
        },
        creative: {
          title: 'Nýsköpun og vörustjórnun',
          description:
            'Hvernig teymi fara frá vandamáli til lausnar - og hvar ferlar ganga oft úrskeiðis',
        },
      },
    },
    contact: {
      title: 'Við skulum tala saman',
      subtitle:
        'Fylltu út eyðublaðið eða bókaðu tíma beint í dagatalinu mínu. Enginn þrýstingur - bara heiðarleg samtal.',
      infoTitle: 'Tengiliðaupplýsingar',
      emailLabel: 'Sendu mér tölvupóst',
      locationLabel: 'Staðsetning',
      locationValue: 'Reykjavík / Um allan heim',
      bookCallTitle: 'Bóka símtal',
      bookCallDesc:
        'Slepptu tölvupóstaleiknum og náðu í tíma í dagatalinu mínu fyrir ókeypis 15 mínútna kynnispjall.',
      viewCalendar: 'Skoða dagatalstíma',
      formTitle: 'Senda skilaboð',
      firstName: 'Fornafn',
      firstNamePlaceholder: 'Jóna',
      lastName: 'Eftirnafn',
      lastNamePlaceholder: 'Jónsdóttir',
      email: 'Netfang',
      emailPlaceholder: 'jona@example.com',
      interestLabel: 'Mig langar að vita meira um...',
      interestOptions: [
        'Stjórnandi í Fyrsta Sinn',
        'Heilbrigðir Ágreiningar',
        'Betri fundir og vinnustofur',
        'Almenn fyrirspurn',
      ],
      message: 'Skilaboð',
      messagePlaceholder:
        'Segðu mér aðeins um markmið þín eða áskoranirnar sem þú stendur frammi fyrir...',
      send: 'Senda skilaboð',
      successTitle: 'Skilaboð send!',
      successMessage:
        'Takk fyrir að hafa samband. Ég kem til baka til þín innan 24 klukkustunda.',
      sendAnother: 'Senda önnur skilaboð',
    },
    conflictCoaching: {
      badge: 'Conflict Coaching',
      title: 'Heilbrigðari Samskipti og',
      titleHighlight: 'Ágreiningar á Vinnustöðum',
      subtitle:
        'Lærðu að takast á við ágreining af öryggi og breyta honum í tækifæri til vaxtar og betri samskipta.',
      duration: '2 dagar (með millibili)',
      audience: 'Fyrir stjórnendur og HR',
      format: 'Vinnustofa',
      bookCta: 'Bóka pláss eða fá tilboð',
      aboutTitle: 'Um Námskeiðið',
      aboutP1:
        'Ágreiningur er óhjákvæmilegur hluti af samstarfi fólks. Spurningin er ekki hvort hann komi upp, heldur hvernig við tökum á honum. Á þessu námskeiði lærir þú aðferðafræði Conflict Coaching til að leiða fólk í gegnum ágreining á uppbyggilegan hátt.',
      aboutP2:
        'Við förum yfir hvernig heilinn bregst við ógn, hvernig við getum róað aðstæður og skapað rými fyrir raunverulegt samtal. Þú færð verkfæri til að hjálpa öðrum (og sjálfum þér) að sjá sjónarhorn annarra og finna sameiginlegan flöt.',
      learnTitle: 'Hvað þú lærir',
      benefits: [
        'Skilningur á eðli átaka og ágreinings',
        'Aðferðir til að greina rót vandans',
        'Betri hlustun og spurningatækni',
        'Aukið sjálfstraust í erfiðum samtölum',
        'Verkfæri til að breyta átökum í tækifæri',
        'Uppbygging trausts í teymi',
      ],
      structureTitle: 'Uppbygging',
      curriculum: [
        {
          day: 'Dagur 1',
          title: 'Grunnurinn og Greining',
          topics: [
            'Hvað er Conflict Coaching?',
            'Mismunandi átakastílar',
            'Taugafræði átaka (Fight/Flight/Freeze)',
            'Greining á stöðunni - Kortlagning',
          ],
        },
        {
          day: 'Millibil',
          title: 'Æfingar og Ígrundun',
          topics: [
            'Verkefni í eigin umhverfi',
            'Ígrundunardagbók',
            'Undirbúningur fyrir dag 2',
          ],
        },
        {
          day: 'Dagur 2',
          title: 'Lausnir og Framkvæmd',
          topics: [
            'Að stýra erfiðum samtölum',
            'Framtíðarsýn og lausnir',
            'Æfingar í hlutverkaleikjum',
            'Aðgerðaáætlun til framtíðar',
          ],
        },
      ],
      forWhom: 'Fyrir hvern?',
      forWhomItems: [
        'Stjórnendur sem vilja efla samskiptafærni sína',
        'HR fagfólk sem styður við teymi og stjórnendur',
        'Teymisstjórar sem vilja byggja upp sálfræðilegt öryggi',
      ],
      inquiry: 'Fyrirspurn',
      questionsTitle: 'Ertu með spurningar?',
      questionsDesc:
        'Hikaðu ekki við að hafa samband ef þú vilt vita hvort þetta námskeið henti þér eða þínu teymi.',
      contactLink: 'Hafa samband',
      ctaTitle: 'Taktu skrefið í átt að betri samskiptum',
      ctaDesc:
        'Bókaðu námskeið fyrir hópinn þinn eða skráðu þig á næsta opna námskeið.',
      ctaCta: 'Hafa samband',
    },
    firstTimeManager: {
      badge: 'Stjórnandi í Fyrsta Sinn',
      title: 'Byggðu upp Sjálfstraust í',
      titleHighlight: 'Nýju Hlutverki',
      subtitle:
        'Hagnýtt 6 vikna námskeið fyrir nýja stjórnendur sem vilja byrja ferilinn sinn af krafti og öryggi.',
      duration: '6 vikur (ein lota á viku)',
      audience: 'Nýir stjórnendur',
      certificate: 'Vottorð að lokum',
      bookCta: 'Skráning og nánari upplýsingar',
      aboutTitle: 'Um Námskeiðið',
      aboutP1:
        'Að taka við stjórnunarstöðu í fyrsta sinn er eitt stærsta stökk sem fólk tekur á starfsferlinum. Allt í einu snýst starfið ekki lengur um það sem þú gerir sjálf/ur, heldur hvernig þú færð aðra til að blómstra.',
      aboutP2:
        'Þetta námskeið er hannað til að brúa bilið. Við förum yfir grunnatriði stjórnunar, allt frá því að halda góða 1:1 fundi til þess að takast á við erfið starfsmannamál. Markmiðið er að þú gangir út með verkfærakistu sem nýtist þér strax á fyrsta degi.',
      learnTitle: 'Hvað þú lærir',
      benefits: [
        'Skýrari sýn á hlutverk stjórnandans',
        'Aukið sjálfstraust í nýju hlutverki',
        'Verkfæri til að veita endurgjöf',
        'Aðferðir til að forgangsraða og stýra tíma',
        'Hæfni til að halda árangursríka fundi',
        'Skilningur á hvernig á að byggja upp teymi',
      ],
      scheduleTitle: 'Dagskráin (6 vikur)',
      curriculum: [
        {
          week: 'Vika 1',
          title: 'Hlutverkaskiptin',
          desc: 'Frá sérfræðingi yfir í stjórnanda. Hvað breytist? Hvernig byggjum við traust?',
        },
        {
          week: 'Vika 2',
          title: 'Samskipti og Endurgjöf',
          desc: 'Að veita og þiggja endurgjöf. Erfið samtöl og hrós.',
        },
        {
          week: 'Vika 3',
          title: 'Teymisuppbygging',
          desc: 'Hvernig verða teymi til? Hlutverk stjórnandans í að skapa menningu.',
        },
        {
          week: 'Vika 4',
          title: 'Fundir og Skipulag',
          desc: 'Að stýra fundum sem skila árangri. Tímastjórnun og forgangsröðun.',
        },
        {
          week: 'Vika 5',
          title: 'Markmiðasetning og Frammistaða',
          desc: 'Hvernig setjum við markmið? Hvernig fylgjum við þeim eftir?',
        },
        {
          week: 'Vika 6',
          title: 'Minn Stjórnunarstíll',
          desc: 'Samantekt og framtíðarsýn. Hvers konar leiðtogi vil ég vera?',
        },
      ],
      forWhom: 'Fyrir hvern?',
      forWhomItems: [
        'Nýir stjórnendur (0-2 ár í starfi)',
        'Sérfræðingar sem eru að taka við teymi',
        'Verkefnastjórar með mannaforráð',
      ],
      inquiry: 'Fyrirspurn',
      groupTitle: 'Hóptilboð?',
      groupDesc:
        'Eruð þið með hóp af nýjum stjórnendum? Ég get haldið þetta námskeið sérstaklega fyrir ykkar fyrirtæki.',
      contactLink: 'Hafa samband',
      ctaTitle: 'Fjárfestu í framtíðarleiðtogum',
      ctaDesc:
        'Gefðu nýjum stjórnendum þann stuðning sem þeir þurfa til að ná árangri.',
      ctaCta: 'Hafa samband',
    },
    betterOnlineMeetings: {
      badge: 'Betri Fjarfundir',
      title: 'Betri Fjarfundir',
      titleHighlight: 'á Netinu',
      subtitle:
        'Hættu að halda leiðinlega fjarfundi. Lærðu að skapa orku, tengingu og árangur í gegnum skjáinn.',
      duration: '2 x 2 klst',
      audience: 'Fyrir alla fundarstjóra',
      online: '100% á netinu',
      bookCta: 'Bóka námskeið',
      aboutTitle: 'Um Námskeiðið',
      aboutP1:
        'Fjarvinna er komin til að vera, en margir fundir eru ennþá bara "venjulegir fundir í tölvu". Það virkar sjaldnast vel.',
      aboutP2:
        'Á þessu stutta og hagnýta námskeiði lærir þú leyndarmálin á bak við frábæra fjarfundi.',
      learnTitle: 'Hvað þú lærir',
      benefits: [
        'Aukin þátttaka á fjarfundum',
        'Betri nýting á tíma fundarmanna',
        'Tækni og tól sem virka',
        'Aðferðir til að brjóta ísinn',
        'Hvernig við höldum orkunni uppi',
        'Skilvirkari ákvarðanatökuferli',
      ],
      structureTitle: 'Uppbygging (2 lotur)',
      sessions: [
        {
          title: 'Lota 1: Grunnurinn og Tæknin',
          desc: 'Hvernig undirbúum við góðan fjarfund? Hvaða tól notum við?',
          topicsLabel: 'Viðfangsefni:',
          topics: [
            'Uppsetning og tæknimál',
            'Miro/Mural og önnur samvinnutól',
            'Að skapa öruggt rými á netinu',
            'Ísbrjótar og tenging',
          ],
        },
        {
          title: 'Lota 2: Aðferðir og Framkvæmd',
          desc: 'Hvernig stýrum við umræðum? Hvernig ljúkum við fundi með skýrum niðurstöðum?',
          topicsLabel: 'Viðfangsefni:',
          topics: [
            'Breakout rooms og hópavinna',
            'Aðferðir við ákvarðanatöku',
            'Að takast á við "Zoom fatigue"',
            'Eftirfylgni og næstu skref',
          ],
        },
      ],
      forWhom: 'Fyrir hvern?',
      forWhomItems: [
        'Verkefnastjórar og teymisstjórar',
        'Leiðbeinendur og kennarar',
        'Allir sem stýra fundum á netinu',
      ],
      inquiry: 'Fyrirspurn',
      privateTitle: 'Einkatímar?',
      privateDesc: 'Ég býð líka upp á einstaklingsráðgjöf.',
      contactLink: 'Hafa samband',
      ctaTitle: 'Gerðu næsta fjarfund frábæran',
      ctaDesc: 'Lærðu tæknina og aðferðirnar sem gera gæfumuninn.',
      ctaCta: 'Hafa samband',
    },
    betterOnlineWorkshops: {
      badge: 'Betri Vinnustofur á Netinu',
      title: 'Betri Vinnustofur',
      titleHighlight: 'á Netinu',
      subtitle:
        'Lærðu að hanna og leiða gagnvirkar, skemmtilegar og árangursríkar vinnustofur á netinu.',
      duration: '3 lotur (3 x 2-3 klst)',
      audience: 'Fyrir leiðbeinendur',
      online: '100% á netinu',
      bookCta: 'Bóka námskeið',
      aboutTitle: 'Um Námskeiðið',
      aboutP1:
        'Að leiða vinnustofur á netinu krefst annarrar nálgunar en í raunheimum.',
      aboutP2:
        'Við notum "Training from the Back of the Room" nálgunina til að skapa virkt nám.',
      learnTitle: 'Hvað þú lærir',
      benefits: [
        'Tækni og tól til að leiða vinnustofur á netinu',
        '"Training from the Back of the Room" aðferðafræðin',
        'Hönnun gagnvirkra og skemmtilegra vinnustofa',
        'Að halda orku og athygli þátttakenda',
        'Hagnýt reynsla af að flytja eigin vinnustofu',
        'Endurgjöf frá leiðbeinanda og öðrum þátttakendum',
      ],
      structureTitle: 'Uppbygging (3 lotur)',
      topicsLabel: 'Viðfangsefni:',
      homework: 'Heimaverkefni',
      sessions: [
        {
          title: 'Lota 1: Tæki, Tól og Tækni',
          desc: 'Grunnurinn - hvaða tól og tækni þurfum við?',
          topics: [
            'Miro/Mural og samvinnutól',
            'Zoom/Teams aðgerðir fyrir leiðbeinendur',
            'Breakout rooms og hópavinna',
            'Tæknileg uppsetning',
          ],
        },
        {
          title: 'Lota 2: Training from the Back of the Room',
          desc: 'Hvernig hönnun við vinnustofur þar sem þátttakendur læra af eigin reynslu?',
          topics: [
            'Aðferðafræði TBR',
            'Hönnun gagnvirkra æfinga',
            'Að skapa nám í stað kennslu',
            'Orkustjórnun og flæði',
          ],
        },
        {
          title: 'Heimaverkefni: Micro-Vinnustofa',
          desc: 'Þátttakendur hanna sína eigin 15 mínútna micro-vinnustofu.',
          topics: [
            'Hönnun á 15 mínútna vinnustofu',
            'Undirbúningur fyrir flutning',
            'Æfing á eigin efni',
          ],
          isHomework: true,
        },
        {
          title: 'Lota 3: Flutningur og Endurgjöf',
          desc: 'Þátttakendur flytja micro-vinnustofuna sína og fá ítarlega endurgjöf.',
          topics: [
            'Flutningur á eigin micro-vinnustofu',
            'Endurgjöf frá leiðbeinanda',
            'Endurgjöf frá jafningjum',
            'Næstu skref',
          ],
        },
      ],
      forWhom: 'Fyrir hvern?',
      forWhomItems: [
        'Þeir sem leiða vinnustofur eða námskeið',
        'Þjálfarar og ráðgjafar',
        'Kennarar og leiðbeinendur',
        'Allir sem vilja bæta færni sína í leiðsögn',
      ],
      inquiry: 'Fyrirspurn',
      groupTitle: 'Hópafsláttur?',
      groupDesc: 'Ég býð upp á sérstök kjör fyrir fyrirtæki og stofnanir.',
      contactLink: 'Hafa samband',
      ctaTitle: 'Vertu meistari í að leiða vinnustofur á netinu',
      ctaDesc: 'Taktu næsta skref í þinni faglegu þróun.',
      ctaCta: 'Hafa samband',
    },
    modernProductManagement: {
      badge: 'Nútíma Vörustjórnun',
      title: 'Nútíma Vörustjórnun',
      titleHighlight: 'fyrir Árangur',
      subtitle:
        'Lærðu aðferðafræði nútíma vörustjórnunar - frá grunnhugtökum til AI-studdrar prótótýpugerðar.',
      duration: '½ - 2 dagar',
      audience: 'Vörustjórar og verkefnastjórar',
      format: 'Staðnámskeið eða Stafrænt',
      bookCta: 'Bóka námskeið',
      aboutTitle: 'Um Námskeiðið',
      aboutP1:
        'Vörustjórnun er orðin ein af mikilvægustu greinum nútíma viðskipta.',
      aboutP2:
        'Þetta námskeið er í boði á þremur stigum. Veldu það snið sem hentar þínum þörfum.',
      learnTitle: 'Hvað þú lærir',
      benefits: [
        'Skilningur á hlutverki vörustjórans í nútíma fyrirtækjum',
        'Algeng módel og ramma vörustjórnunar',
        'Verkfæri til að skilja viðskiptavini og markaðinn',
        'Forgangsröðun og ákvarðanataka í vöruþróun',
        'Hagnýtar æfingar og raunveruleg dæmi',
        'Notkun AI verkfæra til að flýta fyrir prótótýpugerð',
      ],
      formatToggle: {
        inPerson: 'Á staðnum',
        digital: 'Stafrænt (Vendikennsla)',
      },
      inPersonTiers: {
        tier1: {
          name: 'Grunnur',
          duration: '½ dagur',
          subtitle: 'Vörustjórnun 101',
          description: 'Fullkomin kynning.',
          features: [
            'Hvað er vörustjórnun?',
            'Hlutverk vörustjórans',
            'Grunnhugtök og orðaforði',
            'Yfirlit yfir ferlið',
            'Dæmi úr raunveruleikanum',
          ],
        },
        tier2: {
          name: 'Viðbót',
          duration: '1 dagur',
          subtitle: 'Módel og Verkfæri',
          description: 'Grunnurinn + módel og verkfæri.',
          features: [
            'Allt úr Grunni',
            'Lean Startup',
            'Jobs-to-be-Done',
            'Forgangsröðunarverkfæri',
            'Notendaviðtöl',
            'Roadmap',
          ],
          highlighted: true,
        },
        tier3: {
          name: 'Heildstætt',
          duration: '2 dagar',
          subtitle: 'Verkleg Þjálfun + AI',
          description: 'Ítarleg þjálfun með AI.',
          features: [
            'Allt úr Viðbót',
            'Verklegar æfingar',
            'Þróun eigin vöruhugmyndar',
            'AI verkfæri',
            'Frá hugmynd að MVP',
            'Kynning og endurgjöf',
          ],
        },
      },
      digitalTiers: {
        tier1: {
          name: 'Grunnur',
          sessions: '1x 2.5 klst',
          subtitle: 'Vörustjórnun 101',
          description: 'Ein gagnvirk vinnustofa.',
          features: [
            'Hvað er vörustjórnun?',
            'Hlutverk vörustjórans',
            'Grunnhugtök',
            'Gagnvirkar umræður',
            'Kennslumyndbönd',
          ],
        },
        tier2: {
          name: 'Viðbót',
          sessions: '3x 2.5 klst',
          subtitle: 'Módel og Verkfæri',
          description: 'Þrjár vinnustofur.',
          features: [
            'Allt úr Grunni',
            'Lean og Agile',
            'Forgangsröðunarverkfæri',
            'Notendarannsóknir',
            'Æfingar',
            'Kennslumyndbönd',
          ],
          highlighted: true,
        },
        tier3: {
          name: 'Heildstætt',
          sessions: '6x 2.5 klst',
          subtitle: 'Verkleg Þjálfun + AI',
          description: 'Sex vinnustofur með AI.',
          features: [
            'Allt úr Viðbót',
            'Verklegar æfingar',
            'Eigin vöruhugmynd',
            'AI verkfæri',
            'Hópavinna',
            'Kynning',
          ],
        },
      },
      digitalNote:
        'Stafræna námskeiðið notar vendikennslu. Þátttakendur horfa á myndbönd heima og taka þátt í vinnustofum í gegnum Zoom.',
      forWhom: 'Fyrir hvern?',
      forWhomItems: [
        'Vörustjórar',
        'Verkefnastjórar',
        'Stofnendur og frumkvöðlar',
        'Hönnuðir og þróunaraðilar',
      ],
      inquiry: 'Fyrirspurn',
      groupTitle: 'Hópafsláttur?',
      groupDesc: 'Eruð þið fleiri? Ég býð upp á sérstök kjör.',
      contactLink: 'Hafa samband',
      ctaTitle: 'Taktu skrefið',
      ctaDesc: 'Veldu það snið sem hentar og byrjaðu.',
      ctaCta: 'Hafa samband',
    },
  },
  en: {
    navbar: {
      home: 'Home',
      about: 'About',
      services: 'Services',
      contact: 'Contact',
      bookNow: "Let's talk",
      servicesDropdown: {
        overview: 'Overview',
        courses: 'Courses',
        workshops: 'Workshops',
        talks: 'Talks',
      },
    },
    footer: {
      tagline:
        'Coaching and consulting grounded in research, experience, and a healthy dose of honesty - for leaders and teams who want to do better.',
      explore: 'Explore',
      home: 'Home',
      about: 'About',
      services: 'Services',
      contact: 'Contact',
      servicesTitle: 'Service areas',
      newToLeadership: 'New to leadership',
      conflictAndConversations: 'Conflict and difficult conversations',
      meetingsAndFacilitation: 'Better meetings and workshops',
      leadingInComplexity: 'Leading in complexity',
      connectTitle: "Let's Connect",
      substackNote: 'Articles and thinking on Substack',
      copyright: 'All rights reserved.',
      privacy: 'Privacy Policy',
      terms: 'Terms of Service',
    },
    home: {
      hero: {
        badge: 'Leaders · Teams · Communication',
        titleLine1: 'To lead or to manage.',
        titleLine2: 'The difference matters.',
        description:
          "Most leadership development doesn't deliver what we assume it does. The research is fairly uncomfortable about this. There's a better way - if we're honest about what actually works.",
        subDescription:
          'I write about this on Substack and work with leaders and teams who want to make the shift.',
        cta: 'Get in Touch',
        ctaWriting: 'Read my writing',
        substackBadge: 'Writing on Substack',
        substackSub: 'Evidence-based articles',
      },
      cta: {
        title: 'Interested?',
        description:
          "Let's talk about your challenges and see if there's a fit. No pitch, just an honest conversation.",
        bookCall: 'Book a Free Chat',
        readAbout: 'Read About Me',
      },
      writing: {
        sectionLabel: 'Writing & thinking',
        title: 'What I think about',
        subtitle:
          'Articles and series where I go through what the research actually says - and what we often get backwards.',
        series1Label: 'On Feedback',
        series1Title: 'The Feedback Paradox',
        series1Excerpt:
          'We operate under the conviction that feedback is how people grow and improve. The research and lived experience are less comfortable than that. A five-part series going through what we believe works, what actually does, and why the gap matters.',
        series2Label: 'On Agility',
        series2Title: 'The Lessons of Agility',
        series2Excerpt:
          'The Agile movement captured and demonstrated important lessons about how teams succeed in a more complex world. It also went off track in significant ways. This series examines the lessons Agile gave us, the mistakes it made, and what is worth understanding and carrying forward.',
        series3Label: 'On Teams',
        series3Title: 'Developing Highly Effective Teams',
        series3Excerpt:
          "Most people have more bad experiences of teams and teamwork than good ones. That's a real shame, and it's not random. This series looks at what research and the most effective approaches have shown so far, alongside thoughts on how high-performing teams will continue to evolve.",
        readOn: 'Read on Substack',
        viewAll: 'View all writing on Substack',
      },
      ways: {
        sectionLabel: 'How I work',
        title: 'Four ways to work together',
        subtitle:
          'I work in different ways depending on what fits best - 1:1 coaching, facilitated workshops, training, or as an embedded specialist.',
        learnMore: 'Read more',
        viewAll: 'See all services',
        coaching: {
          title: '1:1 Leadership Coaching',
          desc: 'Regular individual sessions where we work through your specific situation, challenges and next steps. Built around your context - not generic advice.',
        },
        facilitation: {
          title: 'Facilitated Workshops',
          desc: 'I facilitate workshops where participants build what they need themselves - under my guidance. The group is at the centre, not me.',
        },
        training: {
          title: 'Training and courses',
          desc: 'A blend of teaching and facilitation - I introduce methods and frameworks, but participants adapt them and add their own experience.',
        },
        embedded: {
          title: 'Embedded specialist',
          desc: 'I work with you on-site, one day a week or 24-30 hours a month - as a leadership coach, team coach, product coach, or project manager.',
        },
      },
    },
    about: {
      title: 'Helgi Gudmundsson',
      intro:
        "Organisational and leadership coach, facilitator and teacher. I've spent over a decade working with leaders, teams and organisations - first in Sweden, now in Iceland.",
      pill1: 'Evidence-based methods',
      pill2: 'Practical - not theoretical',
      storyTitle: 'What I do and why',
      storyP1:
        "I've worked as a coach and facilitator for over ten years - coaching hundreds of leaders and teams across Scandinavia and Iceland, teaching at IHM Business School in Gothenburg, and training over 90 international facilitators as Director of Facilitator Experience at Agile People.",
      storyP2:
        "My background is in Work and Organisational Psychology from the University of Gothenburg, with specialist training in conflict resolution and mediation, and ICF ACC certification in coaching. I'm also co-author of two chapters in the book Agile People Principles, published in 2021.",
      storyP3:
        "My approach is deliberately boundary-spanning - I draw from organisational psychology, behavioural science, complexity thinking and agile coaching, because the problems I work on rarely fit neatly into one discipline. I'm also fairly evidence-based about what works and what doesn't, which occasionally means telling people that the feedback practice they've been using for years is neurologically counterproductive. That conversation usually goes well.",
      publicationLabel: 'Publication',
      publication: {
        title: 'Agile People Principles',
        subtitle: 'Your Call to Action for the Future of Work - published 2021',
        chapters:
          'Co-author of chapters on "Appreciative Feedback" and "Emergent Strategy"',
      },
      credentialsTitle: 'Certifications & Training',
      timelineTitle: 'Background',
      timeline: [
        {
          year: '2006–2013',
          title: 'Business, sales and studies',
          desc: 'BSc in Business and International Business from Reykjavik University. Then sales and marketing at Iceland Post, while beginning further studies in Sweden.',
        },
        {
          year: '2013–2017',
          title: 'Work & Organisational Psychology',
          desc: 'Fil.Cand. from the University of Gothenburg. Specialist training in conflict resolution and mediation. ICF ACC coaching certification at Gothia Academy.',
        },
        {
          year: '2017–2022',
          title: 'International coaching and teaching',
          desc: 'Founder Institute Gothenburg, Global Coach at Egencia (Expedia Group), Director of Facilitator Experience at Agile People - trained ~90 international facilitators and co-authored an ICAgile certified curriculum.',
        },
        {
          year: '2021–2023',
          title: 'Lecturer - IHM Gothenburg',
          desc: '10-week digital course in Modern Product Development. Flipped learning - pre-recorded content and practical workshops.',
        },
        {
          year: '2022–',
          title: 'Orgz - Iceland',
          desc: 'Founded my own practice. Coaching and consulting for leaders and teams - courses in modern product development, conflict coaching and facilitation.',
        },
      ],
      writingLabel: 'Writing & thinking',
      writingTitle: 'What I think about',
      writingSubtitle:
        'Articles and chapters where I go through what the research actually says - and what we often get backwards.',
      outsideWork:
        'Outside work, I chair the Tango Society of Reykjavík, am studying guiding and tour leading - and am working on becoming better at dancing than I am at giving lectures. Results are mixed.',
    },
    services: {
      title: 'Courses, workshops and coaching',
      titleHighlight: 'for leaders and teams',
      subtitle:
        'For leaders and teams who want practical improvement grounded in what actually works - not generic promises about growth and transformation.',
      challengesTitle: 'What I work on',
      challengesSubtitle:
        'Pick the challenge that closest matches what you are dealing with and see how we can work on it together.',
      challenge1Title: 'New to leadership',
      challenge1Subtitle: 'Leadership skills',
      challenge1Desc:
        'The role changes when you become a manager - what worked as a specialist is no longer enough. We work together on understanding what the role actually requires and building confidence in a new context.',
      challenge2Title: 'Conflict and difficult conversations',
      challenge2Subtitle: 'Communication and teams',
      challenge2Desc:
        'Most teams avoid the conversations that matter most. We work with those who want to understand what is actually going on - and how to talk about it in a way that moves things forward.',
      challenge3Title: 'Better meetings and workshops',
      challenge3Subtitle: 'Facilitation and collaboration',
      challenge3Desc:
        "The problem with meetings is rarely the people - it's the design. We work with those who want to design and lead meetings and workshops where people are genuinely active and outcomes actually land.",
      challenge4Title: 'Leading when plans break down',
      challenge4Subtitle: 'Agile leadership',
      challenge4Desc:
        'When long-term plans become obsolete before they are executed, when the problem is genuinely novel - a different kind of leadership is needed. We work with leaders and teams who need to navigate uncertainty, experiment their way forward and develop leadership capability for a complex world.',
      formatsTitle: 'Formats',
      formatsSubtitle:
        'Courses, workshops and talks - choose what fits the situation.',
      seeMore: 'See More',
      perPackage: '/ package',
      bookService: 'Book This Service',
      moreInfoCta: 'More Information',
      moreOptions: 'Other formats',
      moreOptionsSubtitle:
        'In addition to coaching and courses, I also run workshops and talks',
      items: {
        essentials: {
          title: 'First-Time Manager',
          subtitle: 'For new managers',
          description:
            'Taking on a management role for the first time is a significant shift. This six-week course helps you understand what the role actually requires - and gives you practical tools to handle it with confidence.',
          features: [
            'Weekly 1:1 coaching sessions',
            'Templates for 1:1s and feedback conversations',
            'Support between sessions',
            'Personal development plan',
          ],
          price: '$1,499',
        },
        conflict: {
          title: 'Healthy Conflicts',
          subtitle: 'For teams under tension',
          description:
            "Conflict isn't the problem - avoidance is. Courses and workshops that help teams have the conversations that matter, when they matter.\n\nAlso available as a facilitator when conflict is already underway.",
          features: [
            'Courses and workshops on difficult conversations',
            'Building psychological safety in teams',
            'Tools to understand what is actually going on',
            'Facilitation when conflict is already active',
          ],
          price: '$2,500',
        },
        wizardry: {
          title: 'Better Meetings & Workshops',
          subtitle: 'For facilitators and meeting leaders',
          description:
            'Most meetings fail in the design, not the room. We work together on how to design and run meetings and workshops that give people a reason to show up - and something to take away.',
          features: [
            'Designing and facilitating meetings and workshops',
            'Techniques to increase participation and focus',
            'Methods that work equally online and in person',
            'Practical exercises and feedback',
          ],
          price: '$499',
        },
        agile: {
          title: 'Agile Leadership',
          subtitle: 'For leaders navigating change',
          description:
            "Agile isn't a process - it's an approach to uncertainty and complexity. A course about what it actually means to lead in that kind of environment, grounded in research on teams and leadership.",
          features: [
            'Core concepts and frameworks of Agile and Lean',
            "The leader's role in Agile teams",
            'Practical exercises and case studies',
            'Implementation support',
          ],
          price: '$1,899',
        },
      },
      additional: {
        workshops: {
          title: 'Workshops',
          description:
            'Half-day or full-day workshops on-site or online - on teamwork, communication and leadership skills.',
        },
        talks: {
          title: 'Talks',
          description:
            'Talks from 30 to 90 minutes - grounded in research, with an honest view of what we think works and what the evidence actually says.',
        },
        courses: {
          title: 'Courses',
          description:
            'Deeper training in specific areas - from conflict coaching to leadership skills and facilitation.',
        },
      },
    },
    newToLeadership: {
      badge: 'Leadership skills',
      title: 'New to',
      titleHighlight: 'the leadership role',
      intro1:
        "The role changes when you become a manager - and it often happens faster than we expect. What made you good as a specialist doesn't automatically make you good as a manager.",
      intro2:
        'Research on role transitions shows that most new managers underinvest in the things that matter most - building trust, setting clear expectations, and creating conditions where the team can do its best work.',
      heroCta: 'Get in touch',
      signsTitle: 'Does this sound familiar?',
      signs: [
        "You've recently become a manager and aren't sure what the role actually requires",
        "You need to give feedback but aren't sure how to do it in a way that's useful",
        "You're figuring it out as you go - without much support or structure",
        "You're working hard but the team isn't using you the way you'd hoped",
        "You're taking over a team where the culture is already established",
        'You want to understand how to run 1:1s that actually achieve something',
      ],
      whatWeDoTitle: 'What we work on together',
      whatWeDoP1:
        'We look at what your specific role actually requires - not generic leadership advice but what your situation demands.',
      whatWeDoP2:
        'We draw on research on role transitions and leadership development - but shape it to your situation. The goal is that you leave each session with something you can use right away.',
      whatWeDoItems: [
        "The manager's role - what changes and what stays the same",
        'Building trust in a new context',
        'How to give and receive feedback in a way that is actually useful',
        'Running 1:1s that achieve something',
        'Prioritisation and time management in a new role',
        'Creating conditions where the team can work well',
      ],
      waysTitle: 'How we can work on this together',
      waysSubtitle:
        'Choose the format that fits best - or we can discuss what suits you.',
      courseLabel: 'Course',
      workshopLabel: 'Workshop',
      talkLabel: 'Talk',
      course1Title: 'First-Time Manager',
      course1Desc:
        '6-week course covering everything from the role transition to team building.',
      workshop1Title: 'Manager & Leader',
      workshop1Desc:
        'Full-day workshop on leadership style, the role, and real situations.',
      talk1Title: 'What the research says about leadership',
      talk1Desc:
        'A talk on what we know about what makes leaders effective - and what we wrongly assume does.',
      learnMore: 'Read more',
      ctaTitle: "Let's talk",
      ctaDesc: "Tell me about your situation and we'll find what fits best.",
      ctaCta: 'Get in touch',
    },
    conflictAndConversations: {
      badge: 'Communication and teams',
      title: 'Conflict and',
      titleHighlight: 'difficult conversations',
      subtitle:
        'Difficult conversations? Maybe. But rarely for the reason we think.',
      intro1:
        "Conflict isn't the problem. Most teams that are struggling are there because people are avoiding the conversations that need to happen.",
      intro2:
        "Research on team dynamics shows that teams which talk openly about difficult questions consistently outperform those that don't. Psychological safety isn't a buzzword, it's a measurable factor.",
      heroCta: 'Get in touch',
      signsTitle: 'Does this sound familiar?',
      signs: [
        'There are things everyone knows but nobody talks about',
        "People disagree in private but go along with everything in the meeting - and then don't follow through",
        'One or more people on the team are causing problems but nobody addresses it',
        'The team is formally aligned but not really in agreement on anything',
        'Meeting after meeting without anything actually changing',
        'Tension that everyone recognises but nobody gets to the bottom of',
      ],
      whatWeDoTitle: 'What we work on together',
      whatWeDoP1:
        'We look at what is actually going on - not just symptoms but underlying causes. Conflict is often a sign that something else needs attention.',
      whatWeDoP2:
        'We work with both individuals and teams - either through a course, a workshop, or direct facilitation when conflict is already active.',
      whatWeDoItems: [
        'Understanding what is actually happening in the team',
        'Creating space for difficult conversations',
        'The Conflict Coaching methodology',
        'Listening and questioning techniques that open rather than close',
        'Building psychological safety in teams',
        'How to handle active conflict',
      ],
      waysTitle: 'How we can work on this together',
      waysSubtitle:
        'From a course to a workshop to direct facilitation when it is needed.',
      courseLabel: 'Course',
      workshopLabel: 'Workshop',
      talkLabel: 'Talk',
      course1Title: 'Conflict Coaching',
      course1Desc:
        '2-day course in Conflict Coaching methodology - with an interval for practice.',
      workshop1Title: 'How Teams Actually Work',
      workshop1Desc:
        'Workshop on team dynamics, trust, and creating conditions where people talk to each other.',
      talk1Title: 'Conflict is not the problem',
      talk1Desc:
        'A talk on what research says about conflict in teams - and what we can do differently.',
      learnMore: 'Read more',
      ctaTitle: "Let's talk",
      ctaDesc: "Tell me about the situation and we'll figure out what fits.",
      ctaCta: 'Get in touch',
    },
    meetingsAndFacilitation: {
      badge: 'Facilitation and collaboration',
      title: 'Better meetings and workshops',
      titleHighlight: 'that actually work',
      intro1:
        "Most meetings don't fail because people are bad or too busy. They fail because they are designed badly - or not designed at all. That is a solvable problem.",
      intro2:
        'Research on meeting behaviour shows that the majority of meeting time has minimal impact. This is not accidental and it is not inevitable.',
      heroCta: 'Get in touch',
      signsTitle: 'Does this sound familiar?',
      signs: [
        'Meetings are held out of habit - nobody is sure why',
        'Decisions are made but nobody knows who is responsible',
        'Online meetings where half the people are on mute and the rest are checked out',
        'Workshops where everyone listens but nobody participates',
        'Meeting after meeting where the same issues come up again',
        "You put a lot into it but the team doesn't bring back what you hoped for",
      ],
      whatWeDoTitle: 'What we work on together',
      whatWeDoP1:
        'We look at how you design and lead meetings and workshops - whether online or in person. The problem is often in the design.',
      whatWeDoP2:
        'We draw on the "Training from the Back of the Room" methodology and research on attention and participation.',
      whatWeDoItems: [
        'Designing meetings and workshops that deliver outcomes',
        'How to create genuine participation - online and in person',
        'Tools and techniques that actually work',
        'How to facilitate discussions that go in the right direction',
        'Online meetings that people actually want to attend',
        'Workshops where participants are active and learn from experience',
      ],
      waysTitle: 'How we can work on this together',
      waysSubtitle: 'Two to four options available - choose what fits.',
      courseLabel: 'Course',
      workshopLabel: 'Workshop',
      talkLabel: 'Talk',
      course1Title: 'Better Online Meetings',
      course1Desc:
        '2 sessions covering the design and facilitation of online meetings.',
      course2Title: 'Better Online Workshops',
      course2Desc:
        '3 sessions on designing and facilitating workshops - with your own micro-workshop as practice.',
      workshop1Title: 'More Effective Online Meetings',
      workshop1Desc:
        'Workshop where we practice both designing and facilitating online meetings.',
      talk1Title: 'The problem with meetings is the design',
      talk1Desc:
        'A talk on what research says about what makes meetings effective - and what we often get backwards.',
      learnMore: 'Read more',
      ctaTitle: "Let's talk",
      ctaDesc:
        "Tell me what problem you're dealing with and we'll find what fits.",
      ctaCta: 'Get in touch',
    },
    leadingInComplexity: {
      badge: 'Agile leadership',
      title: 'Leading when',
      titleHighlight: 'the plan breaks down',
      intro1:
        "Some situations are complex in a way that conventional approaches can't handle. When the problem is genuinely novel, when nobody knows the right answer in advance - a different kind of leadership is needed.",
      intro2:
        'The Cynefin framework and research on complex systems show that these situations call for a different leadership mode: more experimentation, more sensemaking, less declared certainty.',
      heroCta: 'Get in touch',
      signsTitle: 'Does this sound familiar?',
      signs: [
        'Long-term plans are created but become obsolete before they are executed',
        'The team is working on a problem that has never been solved before',
        "Best practices don't apply in your context",
        'You need to make decisions with insufficient information',
        'The structure is too rigid for what the real challenges require',
        'You need to bring the team with you into uncertainty - without pretending to know everything',
      ],
      whatWeDoTitle: 'What we work on together',
      whatWeDoP1:
        'We look at what leadership looks like when the problem is complex. What does it mean to create conditions where the team can learn and adapt?',
      whatWeDoP2:
        'We draw on Agile and Lean thinking, the Cynefin framework, and research on teams working in uncertainty.',
      whatWeDoItems: [
        'The Cynefin framework - what kind of problem are you dealing with?',
        'How to create conditions where the team can experiment forward',
        'Decision-making in uncertainty without pretending to know everything',
        'Agile and Lean as a way to lead - not as a process',
        'How to listen for weak signals in the environment',
        'Leadership roles in teams that are still developing',
      ],
      waysTitle: 'How we can work on this together',
      waysSubtitle: 'Course, workshop or talk - depending on what fits.',
      courseLabel: 'Course',
      workshopLabel: 'Workshop',
      talkLabel: 'Talk',
      course1Title: 'Agile Leadership',
      course1Desc:
        'A course covering Agile and Lean as leadership capability - not as a project management model.',
      workshop1Title: 'Manager & Leader',
      workshop1Desc:
        'Workshop where we look at leadership style in complex situations.',
      talk1Title: 'Leading in a complex world',
      talk1Desc:
        'A talk on Cynefin, complex systems, and what it means to lead when the problem is genuinely new.',
      learnMore: 'Read more',
      ctaTitle: "Let's talk",
      ctaDesc:
        "Tell me about your situation and we'll see what would be most useful.",
      ctaCta: 'Get in touch',
    },
    coaching: {
      badge: '1:1 Leadership Coaching',
      title: 'Coaching that fits',
      titleHighlight: 'your specific situation',
      intro1:
        "1:1 coaching means taking your situation seriously - not generic advice but a genuine conversation about what you're actually dealing with.",
      intro2:
        "We always start with a free discovery conversation - no commitment. We look at what you're dealing with and whether coaching is the right approach.",
      heroCta: 'Book a discovery call',
      signsTitle: 'When does 1:1 coaching fit?',
      signs: [
        "You're in a new role and need support that's tailored to your situation",
        "You're dealing with a challenge that needs more than a course can provide",
        'You want to work through something at your own pace - with real support',
        'You need someone who can reflect things back and ask difficult questions',
        "You're developing as a leader and want to do it deliberately",
        "You've tried generic advice and it hasn't delivered",
      ],
      whatWeDoTitle: 'How coaching works',
      whatWeDoP1:
        'We meet regularly - usually weekly or every other week. We start by understanding where you are and what you want to work on.',
      whatWeDoP2:
        "I'm a coach, not a consultant. That means I ask, reflect and challenge - but you make the decisions.",
      whatWeDoItems: [
        'A discovery conversation to understand what you need',
        'Regular sessions - at your pace',
        'Conversations that go where the problem actually is',
        'Practical exercises and reflection between sessions',
        'Feedback that is both honest and constructive',
        'The outcome is yours - not mine',
      ],
      relatedTitle: 'What might we work on?',
      relatedSubtitle: '1:1 coaching works well for these challenges:',
      rel1Title: 'New to the leadership role',
      rel1Desc: 'The role changes - we can work through it together.',
      rel2Title: 'Conflict and difficult conversations',
      rel2Desc: 'How to approach what is hard to talk about.',
      rel3Title: 'Leading in complexity',
      rel3Desc: 'Leadership capability when the problem is genuinely new.',
      learnMore: 'Read more',
      ctaTitle: "Let's start with a conversation",
      ctaDesc: 'A discovery call is free and without commitment.',
      ctaCta: 'Book a discovery call',
    },
    embeddedPartner: {
      badge: 'Embedded specialist',
      title: 'A specialist on-site',
      titleHighlight: 'one day a week',
      intro1:
        "Sometimes organisations don't need a full-time hire - they need the right expertise at the right time. I can be with you on-site, one day a week or 24-30 hours a month.",
      intro2:
        'We always start with a discovery conversation where we look at what you need and whether this format fits.',
      heroCta: 'Get in touch',
      detail1Title: 'Time commitment',
      detail1Desc:
        'One day a week or 24-30 hours a month - flexible depending on what you need.',
      detail2Title: 'Working style',
      detail2Desc:
        'On-site with you - as part of the team, not an external consultant dropping in.',
      detail3Title: 'Getting started',
      detail3Desc:
        'We always begin with a free discovery conversation - no commitment required.',
      signsTitle: 'When does this fit?',
      signs: [
        'You need specialist expertise but not a full-time hire',
        "You're in a growth phase and need support in a specific area for a period",
        'You want an outside perspective - but with real knowledge of your context',
        "You're implementing change and need someone to guide the process",
        'A leader or team needs regular support that goes beyond a course',
        "You're too small to justify a permanent hire but need the expertise",
      ],
      rolesTitle: 'What I can be embedded as',
      rolesSubtitle: 'The role is determined by your needs - not a job title.',
      roles: [
        'Leadership coach - supporting leaders and managers',
        'Team coach - working with the team methodically',
        'Product coach - supporting product management and development',
        'Project manager - guiding specific projects',
        'Agile Coach - implementing Agile and Lean practices',
        'Facilitator - leading meetings, workshops and decision-making processes',
      ],
      whatWeDoTitle: 'How the engagement works',
      whatWeDoP1:
        'We start with a discovery conversation where we look at what you need, when and why.',
      whatWeDoP2:
        'If we move forward, the engagement is shaped around your needs - the role, the timing and the goals. We review monthly.',
      whatWeDoItems: [
        'Discovery conversation to understand your needs',
        'Shaped engagement - not a packaged service',
        'On-site - as part of the team',
        'Regular check-ins and feedback',
        'Flexible timing based on needs',
        'Can scale up or down as needed',
      ],
      ctaTitle: "Let's get acquainted",
      ctaDesc: 'A discovery conversation is free and without commitment.',
      ctaCta: 'Get in touch',
    },
    courses: {
      badge: 'Courses',
      title: 'Courses for leaders and teams',
      subtitle:
        'Practical training grounded in research - not generic advice. Choose the course that fits the situation.',
      benefitsTitle: 'What you get from the course:',
      moreInfo: 'More Information',
      customTitle: 'Need something tailored?',
      customDescription:
        'I also design and run in-house courses for organisations - adapted to your context and specific needs.',
      contactUs: 'Get in Touch',
      additional: {
        title: 'More courses',
        subtitle:
          'Specialist courses for those who want to go deeper in a specific area.',
        artOfFacilitation: {
          title: 'The Art of Facilitation',
          subtitle: 'Specialist facilitation training',
          desc: 'A course for those who want to develop facilitation as a professional skill - not just better meetings, but a real understanding of facilitation as a methodology.',
        },
      },
      items: {
        conflictCoaching: {
          title: 'Conflict Coaching',
          subtitle: 'Better communication and healthier conflicts',
          description:
            'Conflict is inevitable - how we handle it is not. This course gives you tools to lead difficult conversations and understand what is actually happening when people disagree.',
          duration: '2 days (with interval)',
          format: 'On-site or digital',
          audience: 'Managers, team leads, HR professionals',
          benefits: [
            'Understanding how conflicts develop and escalate',
            'Methods to map what is actually going on',
            'Better listening and conversation techniques',
            'Increased confidence in difficult conversations',
          ],
        },
        firstTimeManager: {
          title: 'First-Time Manager',
          subtitle: 'Building capability in a new role',
          description:
            'The role changes when you become a manager - what worked as a specialist is no longer enough. This course helps you understand what shifts and gives you the tools to handle it.',
          duration: '6 weeks (one session per week)',
          format: 'On-site or digital',
          audience: 'New managers, aspiring managers',
          benefits: [
            'Clearer understanding of what the role actually requires',
            'Tools for giving and receiving feedback',
            'Methods for prioritising and managing time',
            'Understanding how teams develop',
          ],
        },
        betterOnlineMeetings: {
          title: 'Better Online Meetings',
          subtitle: 'Meetings online that actually deliver',
          description:
            "Online meetings aren't the problem - poor habits are. This course covers what the research says about attention, participation and meeting design.",
          duration: '2 x 2 hours',
          format: 'Digital',
          audience: 'Anyone who leads meetings online',
          benefits: [
            'Increased participation and focus in meetings',
            'Technology and tools that actually work',
            'Methods for creating psychological safety online',
            'More efficient decision-making',
          ],
        },
        betterOnlineWorkshops: {
          title: 'Better Online Workshops',
          subtitle: 'Designing and facilitating workshops',
          description:
            'Moving a workshop to Zoom is not the same as running a good workshop online. This course covers how to design workshops where people are active and learn from their own experience.',
          duration: '3 sessions (3 x 2-3 hrs)',
          format: 'Digital',
          audience: 'Facilitators, coaches, teachers',
          benefits: [
            'Training from the Back of the Room methodology',
            'Designing interactive exercises',
            'Practice delivering your own workshop',
            'Feedback from peers and instructor',
          ],
        },
        modernProductManagement: {
          title: 'Modern Product Management',
          subtitle: 'From idea to successful product',
          description:
            'Product management has evolved. This course covers what that means in practice - from core concepts and common frameworks to practical tools and AI-assisted prototyping.',
          duration: '½ - 2 days',
          format: 'On-site or digital',
          audience: 'Product managers, project managers, founders',
          benefits: [
            'Understanding the product manager role today',
            'Common frameworks: Lean, Agile, Jobs-to-be-Done',
            'Tools for understanding users and the market',
            'Prioritisation and decision-making in product development',
            'Practical exercises and real-world examples',
            'AI tools in prototyping',
          ],
        },
      },
    },
    artOfFacilitation: {
      badge: 'Specialist training',
      title: 'The Art of Facilitation',
      titleHighlight: 'Facilitation as professional skill',
      audienceNote:
        'For those who want to understand facilitation at a deeper level - not just better meetings.',
      aboutP1:
        'This course is for those who want to develop facilitation as a professional skill. We cover what facilitation actually means - how to create conditions where a group can work together effectively.',
      aboutP2:
        "Facilitation is not about being neutral - it's about being conscious of your influence and using it deliberately.",
      duration: '2-3 days (can be split)',
      format: 'On-site or digital',
      audience:
        'Facilitators, trainers, HR professionals, managers who lead a lot',
      bookCta: 'Get in touch',
      learnTitle: 'What you learn',
      benefits: [
        'What facilitation means - and what it does not',
        'How to create conditions where a group can work together',
        'Different facilitation models and when to use them',
        'Neutrality and bias - and how to manage both',
        'How to handle difficult group dynamics',
        'Designing processes that deliver outcomes',
        'How to read the group and adapt in the moment',
      ],
      forWhom: 'Who is it for?',
      forWhomItems: [
        'Those who facilitate a lot - meetings, workshops, consulting',
        'HR professionals and change managers',
        'Coaches and consultants',
        'Managers who want to develop their facilitation skills',
      ],
      structureTitle: 'Structure',
      curriculum: [
        {
          day: 'Day 1',
          title: 'The foundation - What is facilitation?',
          topics: [
            'Facilitation as role and mindset',
            'Different types of facilitation',
            'Group dynamics and how to navigate them',
            'Listening as a technique',
          ],
        },
        {
          day: 'Day 2',
          title: 'In action - Processes and methods',
          topics: [
            'Designing facilitation sessions',
            'Different facilitation models',
            'Handling difficult situations',
            'Practice and feedback',
          ],
        },
        {
          day: 'Day 3 (optional)',
          title: 'Deeper work and reflection',
          topics: [
            'Facilitation values and philosophy',
            'How to develop as a facilitator',
            'Feedback on your own facilitation style',
            'Next steps and development plan',
          ],
        },
      ],
      ctaTitle: "Let's talk",
      ctaDesc: "Tell me about your needs and we'll find what fits best.",
      ctaCta: 'Get in touch',
    },
    workshops: {
      badge: 'Workshops',
      title: 'Workshops for',
      titleHighlight: 'leaders and teams',
      subtitle:
        'Half-day or full-day workshops on-site or online - covering what matters, not what looks good on a slide.',
      inPersonTitle: 'On-Site',
      inPersonSubtitle: 'We meet and work together - face to face',
      onlineTitle: 'Online',
      onlineSubtitle:
        'Live facilitated workshops - not just slides on a screen',
      getQuote: 'Get a Quote',
      customTitle: 'Need something tailored?',
      customDescription:
        "I design workshops to fit the situation - whether it's a small team or a large group. Let's talk about what would be most useful.",
      customCta: "Let's talk",
      items: {
        teamDynamics: {
          title: 'How Teams Actually Work',
          subtitle: 'A workshop on teamwork and communication',
          description:
            "Research shows most people have more bad team experiences than good ones - and that's not random. This workshop covers what the evidence says about how high-functioning teams develop.",
          duration: 'Half day (3-4 hrs) or full day (6-8 hrs)',
          format: 'On-site at your location or venue',
          benefits: [
            'Evidence-based understanding of how teams develop',
            'Practical exercises - not role-plays in a vacuum',
            'Honest conversation about your team and your context',
            'Action plan to take away and use',
          ],
        },
        leadershipIntensive: {
          title: 'Manager & Leader',
          subtitle: 'For new and experienced managers',
          description:
            "The manager and the leader aren't always the same person - and don't need to be. This workshop helps you understand what the role actually demands.",
          duration: 'Full day (8 hrs)',
          format: 'On-site, maximum 12 participants',
          benefits: [
            'Personal leadership style analysis - based on data',
            'Practical discussion of real situations',
            'Tools that are useful in day-to-day management',
            'Conversation with other managers in similar positions',
          ],
        },
        virtualFacilitation: {
          title: 'Better Online Meetings',
          subtitle: 'Meetings people actually want to attend',
          description:
            "The problem with online meetings is rarely the technology - it's the design. This workshop covers how to structure meetings that hold attention and generate participation.",
          duration: '2 x 2 hours (two sessions)',
          format: 'Live online with practical exercises',
          benefits: [
            'Tools and techniques that actually work',
            'Methods for creating participation online',
            'Practice in a safe environment with feedback',
            'Material to take away and use immediately',
          ],
        },
        remoteTeam: {
          title: 'Remote Teams That Work',
          subtitle: 'Building team culture at a distance',
          description:
            "Remote teams need deliberate structure - it doesn't happen by itself. This workshop covers how to build trust, communication norms and connection when the team is distributed.",
          duration: 'Half day (4 hrs)',
          format: 'Live online with breakout rooms',
          benefits: [
            'Communication norms the team sets itself',
            'Tools for maintaining connection at a distance',
            'Methods for building trust when we rarely meet',
            'Templates and checklists to use',
          ],
        },
      },
    },
    talks: {
      badge: 'Talks',
      title: 'Ideas that',
      titleHighlight: 'make people think',
      subtitle:
        'Talks grounded in research and experience - not generic motivation. The content comes from what I write about and teach.',
      chooseTitle: 'Three formats',
      chooseSubtitle:
        'Different structures depending on what the event needs - from a short spark to a working session',
      idealFor: 'Ideal for:',
      topicsLabel: 'Possible topics',
      formatLabel: 'Structure',
      bookTalk: 'Book This Talk',
      popularTopics: 'Topics I speak about',
      popularTopicsSubtitle:
        'All topics grounded in research and real experience - not generic motivational content',
      customTitle: 'Something else in mind?',
      customDescription:
        "I'm happy to adapt a talk to the needs of your event. Let's discuss what would fit best.",
      customCta: 'Get in Touch',
      items: {
        short: {
          title: 'The Spark',
          duration: '30-40 minutes',
          subtitle: 'One idea - tight and direct',
          description:
            'One idea that people are still thinking about when they leave. Works when the slot is short but you want to leave something that sticks.',
          idealFor:
            'Event opening, lunch talk, break in a full-day training programme',
          topics: [
            "Feedback that works - and feedback that doesn't",
            'Why most people have never experienced a truly high-functioning team',
            'The problem with constructive criticism',
            'How we actually learn',
          ],
          format: [
            '25 min talk + 5 min Q&A',
            'One core idea - one clear takeaway',
            'Interactive if time allows',
          ],
        },
        standard: {
          title: 'The Case',
          duration: '60 minutes',
          subtitle: 'The full argument',
          description:
            'Time to work through the topic properly. Arguments, evidence, real examples and something concrete people can take with them.',
          idealFor:
            'Conferences, annual meetings, professional days, corporate events',
          topics: [
            "How high-functioning teams develop - and why most don't",
            'Leaders who make a difference - what the research says',
            "Psychological safety: what it is and what it isn't",
            'Feedback, trust and communication at work',
            'Agile as a mindset - not a process',
          ],
          format: [
            '45-50 min talk + 10-15 min Q&A',
            'Real examples and research findings',
            'Practical takeaways',
          ],
        },
        deepDive: {
          title: 'The Session',
          duration: '90 minutes',
          subtitle: 'We work through it together',
          description:
            "More than a talk - we work with the content together. Works best when the goal isn't just to discuss ideas but to test them.",
          idealFor:
            'Leadership days, development days, smaller groups wanting to go deeper',
          topics: [
            'Conflict Coaching - how to approach conflict constructively',
            'How teams develop: Tuckman, Wheelan and what the research shows',
            'Leading through change - what it means to lead in complexity',
            'Feedback that actually teaches people something',
          ],
          format: [
            '50-60 min talk + 20-25 min exercises + discussion',
            'Small group exercises - we test the content',
            'Open questions and deeper discussion',
            'Something concrete to take away',
          ],
        },
      },
      topicsList: {
        leadership: {
          title: 'Leadership',
          description:
            'What the research says about what makes leaders effective - and what we wrongly assume does',
        },
        teams: {
          title: 'How teams develop',
          description:
            "Tuckman, Wheelan and other research on how groups become teams - or don't",
        },
        agile: {
          title: 'Agile & Lean mindset',
          description:
            'What it means to work in an agile way when the environment is complex and requirements change',
        },
        creative: {
          title: 'Innovation & product management',
          description:
            'How teams move from problem to solution - and where processes often go wrong',
        },
      },
    },
    contact: {
      title: "Let's talk",
      subtitle:
        'Fill out the form or book a time directly in my calendar. No pitch - just an honest conversation.',
      infoTitle: 'Contact Information',
      emailLabel: 'Send me an email',
      locationLabel: 'Location',
      locationValue: 'Reykjavík / Worldwide',
      bookCallTitle: 'Book a Call',
      bookCallDesc:
        'Skip the email back-and-forth and grab a time in my calendar for a free 15-minute intro chat.',
      viewCalendar: 'View Calendar',
      formTitle: 'Send a Message',
      firstName: 'First Name',
      firstNamePlaceholder: 'Jane',
      lastName: 'Last Name',
      lastNamePlaceholder: 'Smith',
      email: 'Email',
      emailPlaceholder: 'jane@example.com',
      interestLabel: "I'd like to know more about...",
      interestOptions: [
        'First-Time Manager',
        'Healthy Conflicts',
        'Better Meetings & Workshops',
        'General inquiry',
      ],
      message: 'Message',
      messagePlaceholder:
        "Tell me a bit about the challenge you're facing or what you're trying to achieve...",
      send: 'Send Message',
      successTitle: 'Message Sent!',
      successMessage:
        "Thanks for reaching out. I'll get back to you within 24 hours.",
      sendAnother: 'Send Another Message',
    },
    conflictCoaching: {
      badge: 'Conflict Coaching',
      title: 'Healthier Communication and',
      titleHighlight: 'Workplace Conflicts',
      subtitle:
        'Learn to handle conflict with confidence and turn it into an opportunity for growth and better communication.',
      duration: '2 days (with interval)',
      audience: 'For managers and HR',
      format: 'Workshop',
      bookCta: 'Book a Spot or Get a Quote',
      aboutTitle: 'About the Course',
      aboutP1:
        "Conflict is an inevitable part of working with people. The question isn't whether it will arise, but how we handle it.",
      aboutP2:
        "We'll cover how the brain responds to threat, how we can calm situations and create space for real conversation.",
      learnTitle: 'What You Learn',
      benefits: [
        'Understanding the nature of conflicts and disagreements',
        'Methods for identifying the root cause',
        'Better listening and questioning techniques',
        'Increased confidence in difficult conversations',
        'Tools for turning conflicts into opportunities',
        'Building trust in teams',
      ],
      structureTitle: 'Structure',
      curriculum: [
        {
          day: 'Day 1',
          title: 'Foundation and Analysis',
          topics: [
            'What is Conflict Coaching?',
            'Different conflict styles',
            'Neuroscience of conflict (Fight/Flight/Freeze)',
            'Situation analysis - Mapping',
          ],
        },
        {
          day: 'Interval',
          title: 'Exercises and Reflection',
          topics: [
            'Assignments in your own environment',
            'Reflection journal',
            'Preparation for day 2',
          ],
        },
        {
          day: 'Day 2',
          title: 'Solutions and Implementation',
          topics: [
            'Managing difficult conversations',
            'Future vision and solutions',
            'Role-play exercises',
            'Action plan for the future',
          ],
        },
      ],
      forWhom: 'Who is it for?',
      forWhomItems: [
        'Managers who want to strengthen their communication skills',
        'HR professionals who support teams and managers',
        'Team leads who want to build psychological safety',
      ],
      inquiry: 'Inquiry',
      questionsTitle: 'Have Questions?',
      questionsDesc:
        "Don't hesitate to reach out if you want to know whether this course is right for you or your team.",
      contactLink: 'Contact',
      ctaTitle: 'Take the Step Toward Better Communication',
      ctaDesc:
        'Book a course for your group or sign up for the next open course.',
      ctaCta: 'Contact',
    },
    firstTimeManager: {
      badge: 'First-Time Manager',
      title: 'Build Confidence in Your',
      titleHighlight: 'New Role',
      subtitle:
        'A practical 6-week course for new managers who want to start their career with power and confidence.',
      duration: '6 weeks (one session per week)',
      audience: 'New managers',
      certificate: 'Certificate upon completion',
      bookCta: 'Registration and More Info',
      aboutTitle: 'About the Course',
      aboutP1:
        'Taking on a management position for the first time is one of the biggest leaps people take in their careers.',
      aboutP2:
        'This course is designed to bridge the gap. We cover management fundamentals from holding good 1:1 meetings to handling difficult personnel matters.',
      learnTitle: 'What You Learn',
      benefits: [
        "Clearer vision of the manager's role",
        'Increased confidence in the new role',
        'Tools for giving feedback',
        'Methods for prioritizing and time management',
        'Skills for running effective meetings',
        'Understanding how to build teams',
      ],
      scheduleTitle: 'Schedule (6 weeks)',
      curriculum: [
        {
          week: 'Week 1',
          title: 'The Role Transition',
          desc: 'From specialist to manager. What changes? How do we build trust?',
        },
        {
          week: 'Week 2',
          title: 'Communication and Feedback',
          desc: 'Giving and receiving feedback. Difficult conversations and praise.',
        },
        {
          week: 'Week 3',
          title: 'Team Building',
          desc: "How do teams form? The manager's role in creating culture.",
        },
        {
          week: 'Week 4',
          title: 'Meetings and Organization',
          desc: 'Running meetings that deliver results. Time management and prioritization.',
        },
        {
          week: 'Week 5',
          title: 'Goal Setting and Performance',
          desc: 'How do we set goals? How do we follow up?',
        },
        {
          week: 'Week 6',
          title: 'My Management Style',
          desc: 'Summary and future vision. What kind of leader do I want to be?',
        },
      ],
      forWhom: 'Who is it for?',
      forWhomItems: [
        'New managers (0-2 years in role)',
        'Specialists taking over teams',
        'Project managers with personnel responsibility',
      ],
      inquiry: 'Inquiry',
      groupTitle: 'Group Offer?',
      groupDesc:
        'Do you have a group of new managers? I can run this course specifically for your company.',
      contactLink: 'Contact',
      ctaTitle: 'Invest in Future Leaders',
      ctaDesc: 'Give new managers the support they need to succeed.',
      ctaCta: 'Contact',
    },
    betterOnlineMeetings: {
      badge: 'Better Online Meetings',
      title: 'Better Online Meetings',
      titleHighlight: 'Online',
      subtitle:
        'Stop running boring online meetings. Learn to create energy, connection, and results through the screen.',
      duration: '2 x 2 hrs',
      audience: 'For all meeting facilitators',
      online: '100% online',
      bookCta: 'Book Course',
      aboutTitle: 'About the Course',
      aboutP1:
        'Remote work is here to stay, but many meetings are still just "regular meetings on a computer." That rarely works well.',
      aboutP2:
        "In this short and practical course, you'll learn the secrets behind great online meetings.",
      learnTitle: 'What You Learn',
      benefits: [
        'Increased participation in online meetings',
        "Better use of attendees' time",
        'Technology and tools that work',
        'Methods for breaking the ice',
        'How to keep energy levels up',
        'More efficient decision-making processes',
      ],
      structureTitle: 'Structure (2 sessions)',
      sessions: [
        {
          title: 'Session 1: The Foundation and Technology',
          desc: 'How do we prepare a good online meeting? What tools do we use?',
          topicsLabel: 'Topics:',
          topics: [
            'Setup and technical terms',
            'Miro/Mural and other collaboration tools',
            'Creating a safe space online',
            'Icebreakers and connection',
          ],
        },
        {
          title: 'Session 2: Methods and Execution',
          desc: 'How do we manage discussions? How do we end meetings with clear outcomes?',
          topicsLabel: 'Topics:',
          topics: [
            'Breakout rooms and group work',
            'Decision-making methods',
            'Dealing with "Zoom fatigue"',
            'Follow-up and next steps',
          ],
        },
      ],
      forWhom: 'Who is it for?',
      forWhomItems: [
        'Project managers and team leads',
        'Facilitators and teachers',
        'Anyone who runs online meetings',
      ],
      inquiry: 'Inquiry',
      privateTitle: 'Private Sessions?',
      privateDesc:
        'I also offer individual consulting for those who want to sharpen their online meeting skills.',
      contactLink: 'Contact',
      ctaTitle: 'Make Your Next Online Meeting Work',
      ctaDesc:
        'Learn the techniques and methods that actually make a difference.',
      ctaCta: 'Contact',
    },
    betterOnlineWorkshops: {
      badge: 'Better Online Workshops',
      title: 'Better Online Workshops',
      titleHighlight: 'Online',
      subtitle:
        'Learn to design and lead interactive, effective online workshops.',
      duration: '3 sessions (3 x 2-3 hrs)',
      audience: 'For facilitators',
      online: '100% online',
      bookCta: 'Book Course',
      aboutTitle: 'About the Course',
      aboutP1:
        'Leading workshops online requires a different approach than in person.',
      aboutP2:
        'We use the "Training from the Back of the Room" approach to create active learning.',
      learnTitle: 'What You Learn',
      benefits: [
        'Technology and tools for leading online workshops',
        '"Training from the Back of the Room" methodology',
        'Designing interactive workshops where people learn from experience',
        'Maintaining participant energy and attention',
        'Practical experience delivering your own workshop',
        'Feedback from instructor and peers',
      ],
      structureTitle: 'Structure (3 sessions)',
      topicsLabel: 'Topics:',
      homework: 'Homework',
      sessions: [
        {
          title: 'Session 1: Tools and Technology',
          desc: 'The first session is about the basics.',
          topics: [
            'Miro/Mural and collaboration tools',
            'Zoom/Teams features for facilitators',
            'Breakout rooms and group work',
            'Technical setup and preparation',
          ],
        },
        {
          title: 'Session 2: Training from the Back of the Room',
          desc: 'How do we design workshops where participants learn from their own experience?',
          topics: [
            'TBR methodology',
            'Designing interactive exercises',
            'Creating learning instead of teaching',
            'Energy management and flow',
          ],
        },
        {
          title: 'Homework: Micro-Workshop',
          desc: 'Participants design their own 15-minute micro-workshop and prepare to deliver it.',
          topics: [
            'Designing a 15-minute workshop',
            'Preparation for delivery',
            'Practice with your own material',
          ],
          isHomework: true,
        },
        {
          title: 'Session 3: Delivery and Feedback',
          desc: 'Participants deliver their micro-workshop and receive detailed feedback.',
          topics: [
            'Delivering your own micro-workshop',
            'Feedback from instructor',
            'Peer feedback',
            'Next steps and continuation',
          ],
        },
      ],
      forWhom: 'Who is it for?',
      forWhomItems: [
        'Those who lead workshops or courses',
        'Coaches and consultants',
        'Teachers and facilitators',
        'Anyone who wants to improve their facilitation skills',
      ],
      inquiry: 'Inquiry',
      groupTitle: 'Group Discount?',
      groupDesc:
        'Do you have a group of facilitators? I offer special rates for companies and organizations.',
      contactLink: 'Contact',
      ctaTitle: 'Run Workshops That Actually Work',
      ctaDesc: 'Take the next step in your facilitation skills.',
      ctaCta: 'Contact',
    },
    modernProductManagement: {
      badge: 'Modern Product Management',
      title: 'Modern Product Management',
      subtitle: 'From idea to successful product',
      description:
        'Learn modern product management methodology - from core concepts and common models to practical tools and AI-assisted prototyping.',
      duration: '½ - 2 days',
      audience: 'Product managers, project managers, founders',
      format: 'On-site or Digital',
      bookCta: 'Book Course',
      aboutTitle: 'About the Course',
      aboutP1:
        'Product management has become one of the most important disciplines in modern business.',
      aboutP2:
        'This course is available at three levels. Choose the format that fits your needs and time.',
      learnTitle: 'What You Learn',
      benefits: [
        'Understanding the product manager role',
        'Common models and tools of product management',
        'Practical exercises and prototyping',
        'Using AI tools in product development',
      ],
      formatToggle: {
        inPerson: 'On-site',
        digital: 'Digital (Flipped Learning)',
      },
      inPersonTiers: {
        tier1: {
          name: 'Foundation',
          duration: '½ day',
          subtitle: 'Product Management 101',
          description: 'Perfect introduction to product management.',
          features: [
            'What is product management?',
            'The product manager role',
            'Core concepts and vocabulary',
            'Overview of the product development process',
            'Real-world examples',
          ],
        },
        tier2: {
          name: 'Extended',
          duration: '1 day',
          subtitle: 'Models and Tools',
          description: 'The foundation plus common models and tools.',
          features: [
            'Everything from Foundation',
            'Lean Startup methodology',
            'Jobs-to-be-Done framework',
            'Prioritization tools (RICE, MoSCoW)',
            'User interviews and research',
            'Roadmap and planning',
          ],
          highlighted: true,
        },
        tier3: {
          name: 'Comprehensive',
          duration: '2 days',
          subtitle: 'Hands-on Training + AI',
          description:
            'In-depth training with practical exercises and prototyping using AI tools.',
          features: [
            'Everything from Extended',
            'Hands-on group exercises',
            'Developing your own product idea',
            'AI tools for prototyping',
            'From idea to MVP',
            'Presentation and feedback',
          ],
        },
      },
      digitalTiers: {
        tier1: {
          name: 'Foundation',
          sessions: '1x 2.5 hrs',
          subtitle: 'Product Management 101',
          description: 'One interactive workshop covering the fundamentals.',
          features: [
            'What is product management?',
            'The product manager role',
            'Core concepts and vocabulary',
            'Interactive discussions',
            'Pre-workshop video lessons',
          ],
        },
        tier2: {
          name: 'Extended',
          sessions: '3x 2.5 hrs',
          subtitle: 'Models and Tools',
          description: 'Three workshops going deeper into models and tools.',
          features: [
            'Everything from Foundation',
            'Lean and Agile methods',
            'Prioritization tools',
            'User research',
            'Exercises between sessions',
            'Video lessons for each session',
          ],
          highlighted: true,
        },
        tier3: {
          name: 'Comprehensive',
          sessions: '6x 2.5 hrs',
          subtitle: 'Hands-on Training + AI',
          description:
            'Six workshops with practical exercises and AI-assisted prototyping.',
          features: [
            'Everything from Extended',
            'Hands-on exercises',
            'Develop your own product idea',
            'AI tools introduced and used',
            'Group work and feedback',
            'Final project presentation',
          ],
        },
      },
      digitalNote:
        'The digital course uses flipped learning. Participants watch video lessons at home and then participate in interactive workshops via Zoom.',
      forWhom: 'Who is it for?',
      forWhomItems: [
        'Product managers who want to strengthen their foundation',
        'Project managers who want to understand product management',
        'Founders and entrepreneurs',
        'Designers and developers who work with product managers',
      ],
      inquiry: 'Inquiry',
      groupTitle: 'Group Discount?',
      groupDesc:
        'Are there several of you from the same company? I offer special rates for groups.',
      contactLink: 'Contact',
      ctaTitle: 'Take the step toward better product management',
      ctaDesc: 'Choose the format that suits you and start the journey.',
      ctaCta: 'Contact',
    },
  },
} as const

export type TranslationKeys = typeof translations.is
